/* ================= RANDOMIZERS ================= */
/* ===== Picker refolosibil de jucători (cu căutare după nume sau @tag) =====
   Fiecare instanță e identificată printr-o cheie. DOM-ul așteptat: <div id="{key}Box">. */
const _playerPicks = {};
function _pickSet(key) { if (!_playerPicks[key]) _playerPicks[key] = new Set(); return _playerPicks[key]; }
function _pickMatch(p, term) { return p.name.toLowerCase().indexOf(term) !== -1 || (p.userTag || '').toLowerCase().indexOf(term) !== -1; }

function renderPlayerPicker(key) {
    const box = document.getElementById(key + 'Box');
    if (!box) return;
    const roster = getSortedPlayers();
    if (!roster.length) { box.innerHTML = `<small style="color:var(--text-secondary);">${t('rand.noPlayers')}</small>`; _playerPicks[key] = new Set(); return; }
    const valid = new Set(roster.map(p => p.dbId));
    _playerPicks[key] = new Set([...(_playerPicks[key] || [])].filter(id => valid.has(id)));
    box.innerHTML = `
        <div class="rand-pick-search-wrap">
            <i class="fas fa-search rand-pick-search-ico"></i>
            <input type="text" id="${key}Search" class="rand-pick-search" placeholder="${t('rand.searchPh')}" oninput="pickerResults('${key}', this.value)" autocomplete="off">
        </div>
        <div id="${key}Results" class="rand-pick-results"></div>
        <div id="${key}Selected" class="rand-pick-chips" style="margin-top:10px;"></div>
        <div id="${key}Count" class="rand-pick-count"></div>`;
    pickerSelected(key);
}

function pickerResults(key, term) {
    const res = document.getElementById(key + 'Results'); if (!res) return;
    term = (term || '').trim().toLowerCase();
    if (!term) { res.innerHTML = ''; return; }
    const sel = _pickSet(key);
    const avatarFn = (typeof avatarHtml === 'function') ? avatarHtml : null;
    const matches = getSortedPlayers().filter(p => !sel.has(p.dbId) && _pickMatch(p, term)).slice(0, 8);
    if (!matches.length) { res.innerHTML = `<div class="rand-pick-nomatch">${t('rand.noMatch')}</div>`; return; }
    res.innerHTML = matches.map(p => {
        const av = avatarFn ? avatarFn(p.avatar, 24) : '';
        const tag = p.userTag ? `<span class="rand-pick-tag">@${window.escHtml(p.userTag)}</span>` : '';
        return `<div class="rand-pick-result" onclick="pickerAdd('${key}','${window.attrJs(p.dbId)}')"><span class="rand-pick-chip-av">${av}</span><span class="rand-pick-result-name">${window.escHtml(p.name)}${tag}</span><i class="fas fa-plus"></i></div>`;
    }).join('');
}

function pickerSelected(key) {
    const sel = document.getElementById(key + 'Selected');
    const cnt = document.getElementById(key + 'Count');
    const avatarFn = (typeof avatarHtml === 'function') ? avatarHtml : null;
    const ids = [..._pickSet(key)];
    if (sel) {
        sel.innerHTML = ids.length ? ids.map(id => {
            const p = ((typeof memberById === 'function') ? memberById(id) : null) || {};
            const nm = p.name || p.displayName || ((typeof displayNameById === 'function' && displayNameById(id)) || id);
            const av = avatarFn ? avatarFn(p.avatar, 22) : '';
            return `<span class="rand-pick-chip is-on"><span class="rand-pick-chip-av">${av}</span>${window.escHtml(nm)}<i class="fas fa-times rand-pick-x" onclick="pickerRemove('${key}','${window.attrJs(id)}')"></i></span>`;
        }).join('') : `<small style="color:var(--text-secondary);">${t('rand.drawEmpty')}</small>`;
    }
    if (cnt) cnt.textContent = ids.length ? (ids.length + ' ' + t('rand.inDraw')) : '';
}

function pickerAdd(key, name) {
    _pickSet(key).add(name);
    const inp = document.getElementById(key + 'Search'); if (inp) inp.value = '';
    const res = document.getElementById(key + 'Results'); if (res) res.innerHTML = '';
    pickerSelected(key);
    if (inp) inp.focus();
}
function pickerRemove(key, name) { _pickSet(key).delete(name); pickerResults(key, (document.getElementById(key + 'Search') || {}).value || ''); pickerSelected(key); }
function pickerAddAll(key) { getSortedPlayers().forEach(p => _pickSet(key).add(p.dbId)); pickerResults(key, (document.getElementById(key + 'Search') || {}).value || ''); pickerSelected(key); }
function pickerClear(key) { _playerPicks[key] = new Set(); const res = document.getElementById(key + 'Results'); if (res) res.innerHTML = ''; pickerSelected(key); }
function pickerNames(key) { return [..._pickSet(key)]; }
window.pickerResults = pickerResults;
window.pickerAdd = pickerAdd;
window.pickerRemove = pickerRemove;
window.pickerAddAll = pickerAddAll;
window.pickerClear = pickerClear;

function renderRandomizers() {
    renderPlayerPicker('randDraw');
    renderPlayerPicker('teamDraw');
}
window.renderPlayerPicker = renderPlayerPicker;

function randomGame() {
    const games = Object.keys(state.catalog);
    if (games.length === 0) {
        showNotification(t('m1.catalogEmpty'), 'error');
        return;
    }
    
    const difficulty = document.getElementById('randomDifficulty').value;
    const maxTime = parseInt(document.getElementById('randomMaxTime').value, 10);
    
    // Filter games based on criteria
    let filteredGames = games;
    
    if (difficulty) {
        filteredGames = filteredGames.filter(name => {
            const game = state.catalog[name];
            return game.difficulty <= parseInt(difficulty);
        });
    }
    
    /* RO: `Number.isFinite`, NU un test de adevăr. Vechiul `if (maxTime && ...)` trata
           0 ca „fără filtru", așa că scriind 0 primeai TOATE jocurile — exact pe dos
           față de ce cere utilizatorul. Câmpul gol rămâne „fără filtru" (parseInt('')
           = NaN), iar 0 sau o valoare negativă primesc un mesaj explicit în loc de
           „niciun joc găsit", care nu spunea de ce.
       EN: finite check instead of truthiness; 0 used to disable the filter entirely. */
    if (Number.isFinite(maxTime)) {
        if (maxTime < 1) {
            showNotification(t('rand.durationInvalid'), 'warning');
            return;
        }
        filteredGames = filteredGames.filter(name => {
            const game = state.catalog[name];
            /* Durata REALĂ medie la masa clubului (din meciurile jucate) are prioritate
               față de cea de pe cutie: „vreau ceva sub 60 de minute" înseamnă cât
               durează la voi, nu ce scrie producătorul. `avgDuration` e calculată la
               hidratare din `matches`; fără meciuri jucate rămâne null și cădem pe
               `duration`. Aceeași pereche de valori e afișată în detaliile jocului. */
            const mins = (typeof game.avgDuration === 'number' && game.avgDuration > 0)
                ? game.avgDuration
                : game.duration;
            return mins <= maxTime;
        });
    }
    
    if (filteredGames.length === 0) {
        showNotification(t('m2.noGamesCriteria'), 'warning');
        return;
    }
    
    // Pick random game
    const randomIndex = Math.floor(Math.random() * filteredGames.length);
    const selectedGame = filteredGames[randomIndex];
    const game = state.catalog[selectedGame];
    
    // Display result
    const resultDiv = document.getElementById('randomGameResult');
    const aj = window.attrJs(selectedGame);
    const banner = (typeof gvBannerHtml === 'function')
        ? gvBannerHtml(selectedGame)
        : `<div style="font-size:1.4em; color:var(--accent-gold); padding:12px;">${window.escHtml(selectedGame)}</div>`;
    resultDiv.innerHTML = `
        <div class="randomizer-result">
            <div class="rand-pick-label"><i class="fas fa-dice"></i> ${t('rand.chosenGame')}</div>
            <div class="gv-card" style="margin-bottom:0;">
                ${banner}
                <div class="gv-card-body">
                    <div class="rand-actions">
                        <button class="btn btn-sm" onclick="setGameForSession('${aj}'); this.closest('.randomizer-result').remove();"><i class="fas fa-calendar-plus"></i> ${t('rand.useForSession')}</button>
                        <button class="btn btn-sm btn-secondary" onclick="showGameDetails('${aj}')"><i class="fas fa-info-circle"></i> ${t('rand.detailsBtn')}</button>
                        <button class="btn btn-sm btn-secondary" onclick="randomGame()"><i class="fas fa-dice"></i> ${t('rand.reroll')}</button>
                    </div>
                </div>
            </div>
        </div>
    `;

    addAuditLog('audit.randomGameSelected', state.currentUser.name, selectedGame);
}

function setGameForSession(gameName) {
    if (!state.catalog[gameName]) {
        showNotification(t('m2.gameNotInCatalog').replace('{game}', gameName), 'error');
        return;
    }
    const game = state.catalog[gameName];
    // Mergem întâi pe tabul de sesiune (renderSessionForm resetează selecția prin
    // clearSessionGame), apoi selectăm jocul prin fluxul NOU §12.2: input ascuns
    // #sessionGame + banner de selecție, prin pickSessionGame (vechiul <select> nu mai există).
    switchTab('session');
    const applyGame = () => {
        if (typeof pickSessionGame === 'function') {
            pickSessionGame(gameName);
        } else {
            const hidden = document.getElementById('sessionGame');
            if (hidden) hidden.value = gameName;
        }
        const dur = document.getElementById('sessionDuration');
        if (dur) dur.value = game.duration || 60;
    };
    applyGame();
    setTimeout(applyGame, 0); // siguranță, dacă randarea tabului vine pe tick-ul următor
    showNotification(t('m2.gameSet').replace('{game}', gameName), 'success');
}

function randomOrder() {
    let roster = getSortedPlayers();
    // Filtrăm după jucătorii adăugați în tragere (dacă picker-ul e prezent)
    if (document.getElementById('randDrawBox')) {
        const sel = new Set(pickerNames('randDraw'));
        roster = roster.filter(p => sel.has(p.dbId));
    }
    if (roster.length < 2) {
        showNotification(t('rand.needTwoSelected'), 'error');
        return;
    }
    const order = [...roster].sort(() => Math.random() - 0.5);
    const avatarFn = (typeof avatarHtml === 'function') ? avatarHtml : null;

    const resultDiv = document.getElementById('randomOrderResult');
    resultDiv.innerHTML = `
        <div class="randomizer-result">
            <h3><i class="fas fa-random"></i> ${t('rand.playerOrder')}</h3>
            <div class="rand-order">
                ${order.map((p, i) => {
        const medal = i === 0 ? '🥇' : i === 1 ? '🥈' : i === 2 ? '🥉' : '';
        const av = avatarFn ? avatarFn(p.avatar, 30) : '';
        return `
                    <div class="rand-order-row${i === 0 ? ' is-first' : ''}">
                        <div class="rand-rank">${i + 1}</div>
                        <div class="rand-avatar">${av}</div>
                        <strong class="rand-order-name">${window.escHtml(p.name)}</strong>
                        ${medal ? `<span class="rand-medal">${medal}</span>` : ''}
                    </div>`;
    }).join('')}
            </div>
            <div class="rand-actions">
                <button class="btn btn-sm" onclick="copyOrderToClipboard(${window.attrJs(JSON.stringify(order.map(p => p.name)))})"><i class="fas fa-copy"></i> ${t('rand.copyOrder')}</button>
                <button class="btn btn-sm btn-secondary" onclick="randomOrder()"><i class="fas fa-random"></i> ${t('rand.reroll')}</button>
            </div>
        </div>
    `;

    addAuditLog('audit.playerOrderRandomized', state.currentUser.name, order.map(p => p.name).join(', '));
}

function copyOrderToClipboard(order) {
    const text = order.map((name, i) => `${i + 1}. ${name}`).join('\n');
    navigator.clipboard.writeText(text).then(() => {
        showNotification(t('m2.orderCopied'), 'success');
    }).catch(err => {
        console.error('Failed to copy:', err);
        showNotification(t('m2.copyError'), 'error');
    });
}

function generateTeams() {
    const teamsCount = parseInt(document.getElementById('teamsCount').value) || 2;
    const playersPerTeam = parseInt(document.getElementById('playersPerTeam').value) || 2;
    const balanceTeams = false;

    
    const players = document.getElementById('teamDrawBox') ? pickerNames('teamDraw') : getSortedPlayers().map(p => p.dbId);
    const totalPlayersNeeded = teamsCount * playersPerTeam;
    
    if (players.length < totalPlayersNeeded) {
        showNotification(t('rand.teamsNeed').replace('{need}', totalPlayersNeeded).replace('{have}', players.length), 'error');
        return;
    }
    
    // Select players
    let selectedPlayers = [...players];
    if (players.length > totalPlayersNeeded) {
        // Shuffle and take needed number
        selectedPlayers = selectedPlayers.sort(() => Math.random() - 0.5).slice(0, totalPlayersNeeded);
    } else {
        // Shuffle all players
        selectedPlayers = selectedPlayers.sort(() => Math.random() - 0.5);
    }
    
    // Create teams (random)
    let teams = [];
    for (let i = 0; i < teamsCount; i++) {
        teams.push([]);
    }
    const shuffled = [...selectedPlayers].sort(() => Math.random() - 0.5);
    for (let i = 0; i < shuffled.length; i++) {
        const teamIndex = i % teamsCount;
        teams[teamIndex].push(shuffled[i]);
    }
    
    // Display result
    const resultDiv = document.getElementById('teamResult');
    const avatarFn = (typeof avatarHtml === 'function') ? avatarHtml : null;
    const teamColors = ['#ff6b35', '#4ecdc4', '#ffd700', '#9b59b6', '#3498db', '#e74c3c', '#27ae60', '#f39c12'];
    resultDiv.innerHTML = `
        <div class="randomizer-result">
            <div class="rand-pick-label"><i class="fas fa-user-friends"></i> ${t('rand.teamsGenerated')}</div>
            <div class="rand-teams">
                ${teams.map((team, i) => {
        const col = teamColors[i % teamColors.length];
        return `
                    <div class="rand-team" style="border-top:3px solid ${col};">
                        <div class="rand-team-head" style="color:${col};"><i class="fas fa-flag"></i> ${t('rand.team')} ${i + 1}</div>
                        ${team.map(player => {
            const m = ((typeof memberById === 'function') ? memberById(player) : null) || (state.members && state.members[player]) || {};
            const nm = m.name || m.displayName || ((typeof displayNameById === 'function' && displayNameById(player)) || player);
            const av = avatarFn ? avatarFn(m.avatar, 26) : '';
            return `<div class="rand-team-member"><span class="rand-avatar">${av}</span><span>${window.escHtml(nm)}</span></div>`;
        }).join('')}
                    </div>`;
    }).join('')}
            </div>
            <div class="rand-actions">
                <button class="btn btn-sm" onclick="copyTeamsToClipboard(${window.attrJs(JSON.stringify(teams))})"><i class="fas fa-copy"></i> ${t('rand.copyTeams')}</button>
                <button class="btn btn-sm btn-secondary" onclick="generateTeams()"><i class="fas fa-user-friends"></i> ${t('rand.reroll')}</button>
            </div>
        </div>
    `;

    addAuditLog('audit.teamsGenerated', state.currentUser.name,
        `${teamsCount} echipe a câte ${playersPerTeam} jucători, random`);
}

function copyTeamsToClipboard(teams) {
    const nm = id => ((typeof displayNameById === 'function' && displayNameById(id)) || id);
    const text = teams.map((team, i) => 
        `Echipa ${i + 1}: ${team.map(nm).join(', ')}`
    ).join('\n');
    
    navigator.clipboard.writeText(text).then(() => {
        showNotification(t('m2.teamsCopied'), 'success');
    }).catch(err => {
        console.error('Failed to copy:', err);
        showNotification(t('m2.copyError'), 'error');
    });
}

/* 8.16-3c (31 oct. 2026): SONDAJELE (renderPolls, cardul, fereastra de creare / editare, votul,
   retragerea, inchiderea, stergerea, sondajele incheiate, delegarea) au fost MUTATE identic in polls.js.
   Aici ramane `checkExpiredPolls`: il cheama o data pe minut app-modules-3.js. EN: polls moved to polls.js. */

function checkExpiredPolls() {
    const now = new Date();
    const expired = [];

    state.polls.forEach(poll => {
        if (poll.active && new Date(poll.expiresAt) <= now) {
            poll.active = false;
            poll.closedAt = now.toISOString();
            expired.push(poll.id);
        }
    });

    /* Persistăm expirarea prin RPC ȚINTIT (nu mai rescriem tot array-ul prin saveState —
       asta ștergea voturile altora). Aceeași condiție de rol ca înainte: Moderator+.
       Pentru ceilalți, marcarea rămâne locală (afișarea e oricum derivată din expiresAt)
       și se persistă când intră un moderator. Idempotent server-side. */
    if (!expired.length) return;
    if (typeof isDemoMode === 'function' && isDemoMode()) return;
    if (typeof roleRank !== 'function' || roleRank(currentClubMyRole()) < 2) return;
    if (typeof sb === 'undefined' || !sb || !currentClubId) return;

    expired.forEach(function (pid) {
        try {
            sb.rpc('poll_close', { p_club_id: currentClubId, p_poll_id: String(pid) })
              .then(function () {}, function () {});
        } catch (e) { /* degradare grațioasă: rămâne marcat local */ }
    });
}

/* 8.16-3c: renderPollCard ... delegarea sondajelor → polls.js. */

/* v9 8.13-5a (29 oct. 2026): CHATUL CLUBULUI (loadChat, rândul și pozele mesajelor, meniul
   mesajului, răspuns / copiere / editare / ștergere / info / redirecționare, bara de răspuns,
   căutarea, ecranul complet, markChatRead, clearChat) a fost MUTAT identic în chat-club.js,
   încărcat imediat după acest fișier. EN: moved to chat-club.js. */



function loadOnlineUsers() {
    const container = document.getElementById('onlineUsers');
    if (!container) return;
    
    const onlineUsers = Object.values(state.onlineUsers).filter(user => 
        Date.now() - user.lastSeen < 300000 // 5 minutes
    );
    
    if (onlineUsers.length === 0) {
        container.innerHTML = `
            <div class="badge badge-secondary">
                <i class="fas fa-user-slash"></i> ${t('dash.noOneOnline')}
            </div>
        `;
        return;
    }
    
    container.innerHTML = onlineUsers.map(user => `
        <div class="badge badge-success">
            <i class="fas fa-circle" style="font-size: 0.7em;"></i>
            ${window.escHtml(user.name)}
            ${user.isAdmin ? ' 👑' : ''}
        </div>
    `).join('');
}

function updateOnlineStatus(isOnline = true) {
    if (!state.currentUser) return;
    
    const userKey = state.currentUser.email || state.currentUser.name;
    
    if (isOnline) {
        state.onlineUsers[userKey] = {
            name: state.currentUser.name,
            isAdmin: state.currentUser.isAdmin,
            lastSeen: Date.now()
        };
    } else {
        delete state.onlineUsers[userKey];
    }
    
    saveState();
    
    // Update online users display if on chat tab
    if (currentTab === 'chat') {
        loadOnlineUsers();
    }
}

/* ================= NOTIFICATION SYSTEM ================= */
function addUserNotification(userEmail, type, message) {
    if (!state.notifications[userEmail]) {
        state.notifications[userEmail] = [];
    }
    
    const notification = {
        id: Date.now(),
        type,
        message,
        timestamp: new Date().toISOString(),
        read: false
    };
    
    state.notifications[userEmail].push(notification);
    
    // Keep only last 50 notifications per user
    if (state.notifications[userEmail].length > 50) {
        state.notifications[userEmail] = state.notifications[userEmail].slice(-50);
    }
    
    saveState();
}

/* Traduce erorile BRUTE de bază de date în mesaje pentru oameni.
   Un singur punct de interceptare (showNotification) acoperă TOATE cele ~50 de
   locuri care afișau `error.message` direct — și pe cele viitoare.
   Înainte, userul vedea „muted_member" sau „new row violates row-level security
   policy...", ceea ce nu-i spune nimic. */
function _friendlyDbError(message) {
    const m = String(message == null ? '' : message);
    if (!m) return null;
    const T = (k, fb) => (typeof window.t === 'function' ? window.t(k) : fb);

    /* Restricție de scriere (mute) — impusă de triggerele din DB. */
    if (/muted_member/i.test(m)) {
        return { text: T('sb.viewOnlyMuted', 'Ești în mod „doar vizualizare".'), type: 'info' };
    }
    /* Lipsă de permisiune: RLS, rang insuficient, privilegii. Toate = „n-ai voie". */
    if (/row[- ]level security|violates row-level security|insufficient_role|permission denied|not authorized|42501/i.test(m)) {
        return { text: T('rbac.noPermission', 'Nu ai permisiunea necesară.'), type: 'error' };
    }
    if (/cannot_mute_admin/i.test(m)) return { text: T('sb.cantMuteAdmin', ''), type: 'error' };
    if (/cannot_mute_self/i.test(m))  return { text: T('sb.cantApplySelf', ''), type: 'error' };
    if (/not_a_member/i.test(m))      return { text: T('sb.notAMember', ''), type: 'error' };
    return null;
}
window._friendlyDbError = _friendlyDbError;

function showNotification(message, type = 'info') {
    const container = document.getElementById('notificationContainer');
    if (!container) return;
    /* Erorile brute de DB devin mesaje umane (vezi _friendlyDbError). */
    const _friendly = _friendlyDbError(message);
    if (_friendly) { message = _friendly.text; type = _friendly.type; }
    if (typeof window.tn === 'function') message = window.tn(message);
    
    const notification = document.createElement('div');
    notification.className = `notification ${type}`;
    
    const icons = {
        success: 'fas fa-check-circle',
        error: 'fas fa-exclamation-circle',
        warning: 'fas fa-exclamation-triangle',
        info: 'fas fa-info-circle'
    };
    
    notification.innerHTML = `
        <div class="notification-icon">
            <i class="${icons[type] || icons.info}"></i>
        </div>
        <div class="notification-content">
            <div class="notification-message">${window.escHtml(message)}</div>
        </div>
    `;
    
    container.appendChild(notification);
    
    // Auto remove after 3 seconds
    setTimeout(() => {
        if (notification.parentNode === container) {
            notification.style.animation = 'slideOutRight 0.3s ease forwards';
            setTimeout(() => {
                if (notification.parentNode === container) {
                    container.removeChild(notification);
                }
            }, 300);
        }
    }, 3000);
}

/* ================= CALENDAR ================= */
function renderCalendar() {
    updateCalendarHeader();
    renderCalendarGrid();
    renderUpcomingEvents();
}

function updateCalendarHeader() {
    const monthNames = t('cal.monthNames').split(',');
    
    document.getElementById('calendarMonth').textContent = 
        `${monthNames[currentMonth]} ${currentYear}`;
}

/* v9 zona 1 — Calendar și evenimente (3 nov. 2026): fără handlere inline (erau 26: tabul Calendar din
   index.html, grila lunii, lista zilei, „Evenimente viitoare", editarea, Google Calendar). O singură delegare
   pe `document`, pe faza de CAPTURĂ (listele și ferestrele se recreează), legată o dată; fiecare acțiune
   cheamă ACEEAȘI funcție, cu aceleași argumente, ca vechiul `onclick`. Id-ul evenimentului e DATĂ
   (`data-ev`, escHtml), nu cod. `data-cal-stop` = zona în care un clic NU deschide evenimentul (RSVP-ul și
   uneltele de pe card — vechiul `event.stopPropagation()`; RSVP-ul are delegarea lui). Tastatura: Enter /
   Space pe CARD (nu și pe butoanele din el, care se apasă normal) deschide evenimentul, ca înainte.
   EN: calendar zone without inline handlers; one capture-phase delegation; same calls; ids as data. */
(function () {
    if (document.__toCalActs) return;
    document.__toCalActs = true;
    document.addEventListener('click', function (e) {
        const el = e.target && e.target.closest ? e.target.closest('[data-cal-act],[data-cal-stop]') : null;
        if (!el || el.hasAttribute('data-cal-stop')) return;
        const a = el.getAttribute('data-cal-act'), id = el.getAttribute('data-ev'), modal = el.closest('.modal');
        switch (a) {
            case 'add': addEventModal(); break;
            case 'today': goToday(); break;
            case 'gsync': syncWithGoogleCalendar(); break;
            case 'export': exportCalendar(); break;
            case 'prev': prevMonth(); break;
            case 'next': nextMonth(); break;
            case 'day': showDayEvents(el.getAttribute('data-day')); break;
            case 'open': openEvent(id); break;
            case 'share': if (typeof openShareMenu === 'function') openShareMenu('event', id, el); break;
            case 'edit': openEditEvent(id); break;
            case 'delete': deleteEvent(id); break;
            case 'day-add': addEventModal(el.getAttribute('data-day')); if (modal) modal.remove(); break;
            case 'close': if (modal) modal.remove(); break;
            case 'close-edit': closeModal('editEventModal'); break;
            case 'save-edit': updateEvent(id); break;
        }
    }, true);
    document.addEventListener('keydown', function (e) {
        if (e.key !== 'Enter' && e.key !== ' ') return;
        const el = e.target;
        if (!el || !el.getAttribute || el.getAttribute('data-cal-act') !== 'open') return;
        e.preventDefault();
        openEvent(el.getAttribute('data-ev'));
    }, true);
})();

function renderCalendarGrid() {
    const grid = document.getElementById('calendarGrid');
    if (!grid) return;
    const firstDay = new Date(currentYear, currentMonth, 1);
    const lastDay = new Date(currentYear, currentMonth + 1, 0);
    const daysInMonth = lastDay.getDate();
    const startingDay = firstDay.getDay();
    const dayNames = t('cal.dayNames').split(',');
    const today = new Date();
    const isCurrentMonth = today.getMonth() === currentMonth && today.getFullYear() === currentYear;

    let html = dayNames.map(d => `<div class="cal-dow">${d}</div>`).join('');
    for (let i = 0; i < startingDay; i++) html += `<div class="cal-cell cal-empty"></div>`;

    for (let day = 1; day <= daysInMonth; day++) {
        const dateStr = `${currentYear}-${String(currentMonth + 1).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
        const eventsOnDay = (state.events || []).filter(ev => ev.date && ev.date.startsWith(dateStr));
        const isToday = isCurrentMonth && day === today.getDate();
        const n = eventsOnDay.length;
        let dots = '';
        if (n) {
            const shown = Math.min(n, 3);
            dots = '<div class="cal-dots">' + Array.from({ length: shown }).map((_, k) => {
                const gold = eventsOnDay[k] && eventsOnDay[k].type === 'tournament';
                return `<span class="cal-dot${gold ? ' gold' : ''}"></span>`;
            }).join('') + (n > 3 ? `<span class="cal-more">+${n - 3}</span>` : '') + '</div>';
        }
        const title = n ? eventsOnDay.map(e => e.title).join(', ').replace(/"/g, '&quot;') : '';
        html += `<div class="cal-cell${isToday ? ' today' : ''}${n ? ' has-event' : ''}" data-cal-act="day" data-day="${dateStr}" title="${title}"><span class="cal-num">${day}</span>${dots}</div>`;
    }
    grid.innerHTML = html;
}

function showDayEvents(dateStr) {
    const events = state.events.filter(event => 
        event.date.startsWith(dateStr)
    );
    
    const modal = document.createElement('div');
    modal.className = 'modal active';
    modal.dataset.day = dateStr;
    
    const date = new Date(dateStr);
    const dateFormatted = date.toLocaleDateString(appDateLocale(), { 
        weekday: 'long', 
        year: 'numeric', 
        month: 'long', 
        day: 'numeric' 
    });
    
    modal.innerHTML = `
        <div class="modal-content">
            <div class="modal-header">
                <h2><i class="fas fa-calendar-day"></i> ${dateFormatted}</h2>
                <button class="modal-close" data-cal-act="close" aria-label="${t('common.close')}">×</button>
            </div>
            
            <div>
                ${events.length === 0 ? 
                    '<p class="text-center text-muted">' + t('cal.noEventsDay') + '</p>' : 
                    events.map(event => {
                        const time = new Date(event.date).toLocaleTimeString(appTimeLocale(), { 
                            hour: '2-digit', 
                            minute: '2-digit' 
                        });
                        
                        /* Card COMPACT + clickabil -> același pop-up de detalii ca în lista
                           „Următoarele evenimente" (consecvență §6). Descrierea nu mai apare
                           aici; RSVP-ul rămâne (3 butoane pe un rând) și nu propagă click-ul. */
                        return `
                            <div class="cal-day-event clickable" role="button" tabindex="0"
                                 title="${t('ev.openDetails')}"
                                 data-cal-act="open" data-ev="${window.escHtml(String(event.id))}"
                                 style="
                                background: var(--bg-secondary);
                                padding: 15px;
                                margin: 10px 0;
                                border-radius: 10px;
                                border-left: 4px solid ${event.type === 'tournament' ? 'var(--accent-gold)' : 'var(--accent-primary)'};
                            ">
                                <div style="display: flex; justify-content: space-between; align-items: center; gap:8px;">
                                    <h4 style="margin: 0; color: var(--accent-gold);">${window.escHtml(event.title)}</h4>
                                    <span class="badge ${event.type === 'tournament' ? 'badge-warning' : 'badge-primary'}">
                                        ${event.type === 'tournament' ? '🏆 ' + t('session.tournament') : '🎮 ' + t('ra.fallbackName')}
                                    </span>
                                </div>
                                <div style="color: var(--text-secondary); margin-top: 8px;">
                                    <i class="fas fa-clock"></i> ${time}
                                    ${event.location ? ` • <i class="fas fa-map-marker-alt"></i> ${window.escHtml(event.location)}` : ''}
                                </div>
                                <div style="margin-top: 12px;">
                                    <small style="color: var(--text-secondary); display:block; margin-bottom:10px;">
                                        ${t('ev.organizer')}: ${window.escHtml((typeof displayNameById === 'function' && displayNameById(event.organizer)) || event.organizer || '—')}
                                    </small>
                                    <div data-cal-stop>${rsvpControlsHtml(event, { scope: 'day' })}</div>
                                </div>
                            </div>
                        `;
                    }).join('')
                }
            </div>
            
            <div class="btn-group" style="margin-top: 20px;">
                <button class="btn" data-cal-act="day-add" data-day="${dateStr}">
                    <i class="fas fa-plus"></i> ${t('cal.addEvent')}
                </button>
                <button class="btn btn-secondary" data-cal-act="close">
                    <i class="fas fa-times"></i> ${t('common.close')}
                </button>
            </div>
        </div>
    `;
    
    document.body.appendChild(modal);
}

function renderUpcomingEvents() {
    const container = document.getElementById('upcomingEvents');
    if (!container) return;
    const now = new Date();
    const upcoming = (state.events || [])
        .filter(ev => new Date(ev.date) > now)
        .sort((a, b) => new Date(a.date) - new Date(b.date))
        .slice(0, 8);

    if (upcoming.length === 0) {
        container.innerHTML = `
            <div class="cal-empty-note">
                <i class="fas fa-calendar-times"></i>
                <h4>${t('cal.noUpcoming')}</h4>
                <p>${t('cal.planFirst')}</p>
            </div>`;
        return;
    }

    const monthsShort = (t('cal.monthNames') || '').split(',');
    const avatarFn = (typeof avatarHtml === 'function') ? avatarHtml : null;

    container.innerHTML = upcoming.map(event => {
        const d = new Date(event.date);
        const dayNum = d.getDate();
        const monShort = (monthsShort[d.getMonth()] || '').slice(0, 3);
        const timeStr = d.toLocaleTimeString(appTimeLocale(), { hour: '2-digit', minute: '2-digit' });
        const isT = event.type === 'tournament';

        const map = (event.participants && typeof event.participants === 'object' && !Array.isArray(event.participants))
            ? event.participants : rsvpMap(event.participants);
        const yesList = rsvpList(map, 'yes');
        let attendees = '';
        if (yesList.length && avatarFn) {
            const shown = yesList.slice(0, 6);
            attendees = `<div class="cal-attendees">${shown.map(n => `<span class="cal-att" title="${window.escHtml((typeof displayNameById === 'function' && displayNameById(n)) || n)}">${avatarFn(((typeof memberById === 'function' && memberById(n)) || {}).avatar, 24)}</span>`).join('')}${yesList.length > 6 ? `<span class="cal-att-more">+${yesList.length - 6}</span>` : ''}</div>`;
        }

        const canDel = (typeof canDeleteEvent === 'function') ? canDeleteEvent(event) : false;
        const canEd = (typeof canEditEvent === 'function') ? canEditEvent(event) : false;
        const evId = window.escHtml(String(event.id));
        /* Acțiunile stau pe UN rând și NU deschid pop-up-ul de detalii (`data-cal-stop`: delegarea din
           capul fișierului le tratează, iar zona din jurul lor nu deschide cardul — vechiul stopPropagation). */
        const tools = `<div class="cal-event-tools" data-cal-stop>
                <button class="cal-tool" title="${t('common.share')}" aria-label="${t('common.share')}" data-cal-act="share" data-ev="${evId}"><i class="fas fa-share-nodes"></i></button>
                ${canEd ? `<button class="cal-tool" title="${t('event.editTitle')}" aria-label="${t('event.editTitle')}" data-cal-act="edit" data-ev="${evId}"><i class="fas fa-pen"></i></button>` : ''}
                ${canDel ? `<button class="cal-tool danger" title="${t('cal.deleteEvent')}" aria-label="${t('cal.deleteEvent')}" data-cal-act="delete" data-ev="${evId}"><i class="fas fa-trash"></i></button>` : ''}
            </div>`;

        /* Card COMPACT (pattern Discover §13d): titlu + dată/oră + locație + RSVP.
           Descrierea și restul detaliilor trec în pop-up (openEvent). */
        return `
            <div class="cal-event clickable${isT ? ' tournament' : ''}" role="button" tabindex="0"
                 title="${t('ev.openDetails')}"
                 data-cal-act="open" data-ev="${evId}">
                <div class="cal-event-date">
                    <span class="cal-event-day">${dayNum}</span>
                    <span class="cal-event-mon">${window.escHtml(monShort)}</span>
                </div>
                <div class="cal-event-body">
                    <div class="cal-event-top">
                        <div class="cal-event-title">${isT ? '🏆' : '🎮'} ${window.escHtml(event.title)}</div>
                        ${tools}
                    </div>
                    <div class="cal-event-meta">
                        <span><i class="fas fa-clock"></i> ${timeStr}</span>
                        ${event.location ? `<span><i class="fas fa-map-marker-alt"></i> ${window.escHtml(event.location)}</span>` : ''}
                    </div>
                    ${attendees}
                    <div class="cal-event-rsvp" data-cal-stop>${rsvpControlsHtml(event, { scope: 'list' })}</div>
                </div>
            </div>`;
    }).join('');
}

/* ============================================================
   §6 — Pop-up cu TOATE detaliile unui eveniment (single-location).
   Lista rămâne compactă; aici apare tot ce a fost ascuns: descriere
   completă, organizator, locație, participanți (cu nume) și RSVP.
   Închiderea (×, tap pe fundal, Escape) trece prin ciclul de viață
   al modalelor reparat la §1 -> nodul e eliminat din DOM, deci se
   poate redeschide la nesfârșit.
   ============================================================ */
function openEvent(eventId) {
    const event = (state.events || []).find(e => String(e.id) === String(eventId));
    if (!event) { showNotification(t('sb.eventNotFoundDot'), 'error'); return; }

    const existing = document.getElementById('eventDetailModal');
    if (existing) existing.remove();

    const d = new Date(event.date);
    const evType = event.type || (event.status === 'tournament' ? 'tournament' : 'session');
    const isT = evType === 'tournament';
    /* Badge-ul reflectă TIPUL REAL. Înainte, „meeting"/„other" apăreau greșit ca
       „Session", pentru că tipul nu era persistat deloc (se deducea din `status`). */
    /* ⚠ Iconițele trebuie să fie IDENTICE cu cele din cheile `event.type*`
       (i18n.js): titlul folosește `tm.icon`, iar insigna folosește textul cheii,
       care își poartă propriul emoji. Înainte difereau la „meeting" (🗓️ vs 🤝) și
       „other" (📌 vs 📅), deci titlul și insigna ar fi arătat altceva.
       ⛔ NU scoate emoji-ul din cheile i18n: ele sunt folosite și în listele
         derulante de tip eveniment (liniile ~2062 și ~2258), unde e dorit.
       EN: icons must match the emoji embedded in the i18n keys, since the title
           uses this icon and the badge uses the key text. Don't strip the emoji
           from the keys — the type dropdowns rely on it. */
    const TYPE_META = {
        session: { icon: '🎮', k: 'event.typeSession', cls: 'badge-primary' },
        tournament: { icon: '🏆', k: 'event.typeTournament', cls: 'badge-warning' },
        meeting: { icon: '🤝', k: 'event.typeMeeting', cls: 'badge-primary' },
        other: { icon: '📅', k: 'event.typeOther', cls: 'badge-primary' }
    };
    const tm = TYPE_META[evType] || TYPE_META.session;
    const dateFull = d.toLocaleDateString(appDateLocale(), { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' });
    const timeStr = d.toLocaleTimeString(appTimeLocale(), { hour: '2-digit', minute: '2-digit' });
    const organizer = (typeof displayNameById === 'function' && displayNameById(event.organizer)) || event.organizer || '—';
    const canDel = (typeof canDeleteEvent === 'function') ? canDeleteEvent(event) : false;
    const canEd = (typeof canEditEvent === 'function') ? canEditEvent(event) : false;

    const modal = document.createElement('div');
    modal.className = 'modal active';
    modal.id = 'eventDetailModal';
    modal.dataset.eventId = String(event.id);
    modal.onclick = (e) => { if (e.target === modal) modal.remove(); };

    const row = (icon, label, value) => `
        <div class="ev-row">
            <div class="ev-row-label"><i class="fas ${icon}"></i> ${label}</div>
            <div class="ev-row-value">${value}</div>
        </div>`;

    modal.innerHTML = `
        <div class="modal-content" style="max-width:560px;">
            <div class="modal-header">
                <h2>${tm.icon} ${window.escHtml(event.title)}</h2>
                <button class="modal-close" data-ev-act="close" aria-label="${t('common.close')}">×</button>
            </div>

            <div style="margin-bottom:14px;">
                <span class="badge ${tm.cls}">${t(tm.k)}</span>
            </div>

            ${row('fa-calendar-day', t('ev.when'), window.escHtml(dateFull) + ' &middot; ' + window.escHtml(timeStr))}
            ${event.location ? row('fa-map-marker-alt', t('ev.location'), window.escHtml(event.location)) : ''}
            ${row('fa-user', t('ev.organizer'), window.escHtml(organizer))}
            ${row('fa-align-left', t('ev.description'),
                event.description
                    ? `<span style="white-space:pre-wrap;">${window.linkifyEscaped(window.escHtml(event.description))}</span>`
                    : `<span style="color:var(--text-secondary);">${t('ev.noDescription')}</span>`)}

            <div style="margin-top:16px; border-top:1px solid var(--border); padding-top:14px;">
                <strong style="display:block; margin-bottom:8px;"><i class="fas fa-reply"></i> ${t('ev.yourAnswer')}</strong>
                ${rsvpControlsHtml(event)}
            </div>

            <div class="btn-group" style="margin-top:18px;">
                <button class="btn btn-secondary" data-ev-act="share">
                    <i class="fas fa-share-nodes"></i> ${t('common.share')}
                </button>
                ${canEd ? `<button class="btn btn-primary" data-ev-act="edit">
                    <i class="fas fa-pen"></i> ${t('common.edit')}
                </button>` : ''}
                ${canDel ? `<button class="btn btn-danger" data-ev-act="delete">
                    <i class="fas fa-trash"></i> ${t('cal.deleteEvent')}
                </button>` : ''}
                <button class="btn btn-secondary" data-ev-act="close">
                    <i class="fas fa-times"></i> ${t('common.close')}
                </button>
            </div>
        </div>`;

    /* v9 8.16-4f (1 nov. 2026): fără onclick — un ascultător pe fereastră (dispare odată cu ea); id-ul
       evenimentului vine din obiect, nu din cod. Fereastra se deschide acum și din chat („Deschide" pe
       cardul evenimentului). EN: delegated listener, no inline handlers. */
    modal.addEventListener('click', function (e) {
        const el = e.target && e.target.closest ? e.target.closest('[data-ev-act]') : null;
        if (!el || !modal.contains(el)) return;
        const a = el.getAttribute('data-ev-act'), id = String(event.id);
        if (a === 'close') closeModal('eventDetailModal');
        else if (a === 'share' && typeof openShareMenu === 'function') openShareMenu('event', id, el);
        else if (a === 'edit' && typeof openEditEvent === 'function') openEditEvent(id);
        else if (a === 'delete' && typeof deleteEvent === 'function') deleteEvent(id);
    });
    document.body.appendChild(modal);
}
window.openEvent = openEvent;

/* ============================================================
   Editare eveniment — TOATE câmpurile, pre-populate.
   Acces: admin (rang>=3) SAU organizatorul (canEditEvent).
   Autorizarea reală e server-side în RLS (§23.e); asta e doar UX.
   Refolosește ACELEAȘI id-uri de câmpuri ca formularul de creare,
   deci `updateEvent` le citește cu aceeași logică.
   ============================================================ */
function openEditEvent(eventId) {
    const event = (state.events || []).find(e => String(e.id) === String(eventId));
    if (!event) { showNotification(t('sb.eventNotFoundDot'), 'error'); return; }
    if (typeof canEditEvent === 'function' && !canEditEvent(event)) {
        showNotification(t('rbac.noPermission'), 'error'); return;
    }

    /* Închidem pop-up-ul de detalii (dacă e deschis), ca să nu avem 2 modale suprapuse
       și, mai important, id-uri de câmpuri duplicate în DOM. */
    const det = document.getElementById('eventDetailModal'); if (det) det.remove();
    const existing = document.getElementById('editEventModal'); if (existing) existing.remove();

    const d = new Date(event.date);
    const pad = n => String(n).padStart(2, '0');
    const dVal = `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
    const tVal = `${pad(d.getHours())}:${pad(d.getMinutes())}`;
    const curType = event.type || (event.status === 'tournament' ? 'tournament' : 'session');
    const opt = (v, label) => `<option value="${v}"${curType === v ? ' selected' : ''}>${label}</option>`;

    const modal = document.createElement('div');
    modal.className = 'modal active';
    modal.id = 'editEventModal';
    modal.onclick = (e) => { if (e.target === modal) modal.remove(); };
    modal.innerHTML = `
        <div class="modal-content">
            <div class="modal-header">
                <h2><i class="fas fa-pen"></i> ${t('event.editTitle')}</h2>
                <button class="modal-close" data-cal-act="close-edit" aria-label="${t('common.close')}">×</button>
            </div>

            <div class="form-group">
                <label for="eventTitle"><i class="fas fa-heading"></i> ${t('event.eTitle')}</label>
                <input type="text" id="eventTitle" class="form-control" placeholder="${t('event.eTitlePh')}" value="${window.escHtml(event.title || '')}">
            </div>

            <div class="form-row">
                <div class="form-group">
                    <label for="eventDate"><i class="fas fa-calendar"></i> ${t('event.date')}</label>
                    <input type="date" id="eventDate" class="form-control" value="${dVal}">
                </div>
                <div class="form-group">
                    <label for="eventTime"><i class="fas fa-clock"></i> ${t('event.time')}</label>
                    <input type="time" id="eventTime" class="form-control" value="${tVal}">
                </div>
            </div>

            <div class="form-group">
                <label for="eventLocation"><i class="fas fa-map-marker-alt"></i> ${t('event.location')}</label>
                <input type="text" id="eventLocation" class="form-control" placeholder="${t('event.locationPh')}" value="${window.escHtml(event.location || '')}">
            </div>

            <div class="form-group">
                <label for="eventType"><i class="fas fa-tag"></i> ${t('event.type')}</label>
                <select id="eventType" class="form-control">
                    ${opt('session', t('event.typeSession'))}
                    ${opt('tournament', t('event.typeTournament'))}
                    ${opt('meeting', t('event.typeMeeting'))}
                    ${opt('other', t('event.typeOther'))}
                </select>
            </div>

            <div class="form-group">
                <label for="eventDescription"><i class="fas fa-align-left"></i> ${t('event.description')}</label>
                <textarea id="eventDescription" class="form-control" rows="3" placeholder="${t('event.descriptionPh')}">${window.escHtml(event.description || '')}</textarea>
            </div>

            ${_eventCapacityFieldHtml(event.maxParticipants)}

            ${(typeof reminderPickerHTML === 'function') ? reminderPickerHTML(event.reminders || null) : ''}

            <div class="btn-group" style="margin-top:18px;">
                <button class="btn btn-primary" data-cal-act="save-edit" data-ev="${window.escHtml(String(event.id))}">
                    <i class="fas fa-save"></i> ${t('common.save')}
                </button>
                <button class="btn btn-secondary" data-cal-act="close-edit">
                    <i class="fas fa-times"></i> ${t('common.cancel')}
                </button>
            </div>
        </div>`;

    document.body.appendChild(modal);
}
window.openEditEvent = openEditEvent;

function prevMonth() {
    currentMonth--;
    if (currentMonth < 0) {
        currentMonth = 11;
        currentYear--;
    }
    renderCalendar();
}
function goToday() {
    const now = new Date();
    currentMonth = now.getMonth();
    currentYear = now.getFullYear();
    renderCalendar();
}
window.goToday = goToday;

function nextMonth() {
    currentMonth++;
    if (currentMonth > 11) {
        currentMonth = 0;
        currentYear++;
    }
    renderCalendar();
}

/* ============================================================
   REMINDERE — component UI reutilizabil (§5, stil Google Calendar).
   Folosit în formularele de eveniment / poll / game vote. Randează un
   toggle + o listă de reguli (offset în minute înainte de deadline).
   `reminderPickerHTML(prefill)` -> HTML; `readReminderConfig(scopeId)` ->
   { enabled, rules:[{offset}] }. Offset-urile predefinite acoperă cazurile
   uzuale; adminul poate adăuga mai multe rânduri.
   ============================================================ */
const REMINDER_OFFSETS = [
    { v: 10, k: 'rem.min10' }, { v: 30, k: 'rem.min30' }, { v: 60, k: 'rem.hour1' },
    { v: 120, k: 'rem.hour2' }, { v: 360, k: 'rem.hour6' }, { v: 720, k: 'rem.hour12' },
    { v: 1440, k: 'rem.day1' }, { v: 2880, k: 'rem.day2' }, { v: 10080, k: 'rem.week1' }
];

function _reminderRuleRow(offset) {
    const opts = REMINDER_OFFSETS.map(o =>
        `<option value="${o.v}" ${o.v === offset ? 'selected' : ''}>${t(o.k)}</option>`).join('');
    return `<div class="rem-row">
        <i class="fas fa-bell rem-bell"></i>
        <select class="form-control rem-select reminder-offset">${opts}</select>
        <button type="button" class="btn btn-secondary rem-del" data-action="rem-del" title="${t('common.delete')}"><i class="fas fa-times"></i></button>
    </div>`;
}

function reminderPickerHTML(prefill, opts) {
    opts = opts || {};
    const cfg = (prefill && typeof prefill === 'object') ? prefill : {};
    const enabled = cfg.enabled !== false && Array.isArray(cfg.rules) && cfg.rules.length > 0;
    const rules = (Array.isArray(cfg.rules) && cfg.rules.length) ? cfg.rules : [{ offset: 1440 }];
    const rowsHtml = rules.map(r => _reminderRuleRow(Number(r.offset) || 1440)).join('');
    /* Stare dezactivată (ex. game vote fără deadline): secțiune opacă, needitabilă,
       cu notă explicativă. Se reactivează prin setReminderPickerEnabled(true). */
    const disabled = !!opts.disabled;
    return `<div class="form-group reminder-picker" id="reminderPicker" style="${disabled ? 'opacity:.5; pointer-events:none;' : ''}">
        <label style="display:flex; align-items:center; gap:8px;">
            <input type="checkbox" id="reminderEnabled" ${enabled && !disabled ? 'checked' : ''} ${disabled ? 'disabled' : ''}
                data-action="rem-toggle">
            <i class="fas fa-bell"></i> ${t('rem.label')}
        </label>
        <div id="reminderRules" style="display:${enabled && !disabled ? 'block' : 'none'}; margin-top:8px;">
            <div id="reminderRulesList">${rowsHtml}</div>
            <button type="button" class="btn btn-secondary rem-add" data-action="rem-add">
                <i class="fas fa-plus"></i> ${t('rem.addRule')}
            </button>
            <p style="color:var(--text-secondary); font-size:.8em; margin-top:6px;">${t('rem.hint')}</p>
        </div>
        <p id="reminderNeedsDeadline" style="color:var(--text-secondary); font-size:.8em; margin-top:6px; display:${disabled ? 'block' : 'none'};">
            <i class="fas fa-circle-info"></i> ${t('rem.needsDeadline')}
        </p>
    </div>`;
}

/* Activează/dezactivează vizual picker-ul (varianta B pentru game vote:
   remindere disponibile doar după ce e setat un deadline). */
function setReminderPickerEnabled(on) {
    const picker = document.getElementById('reminderPicker');
    const chk = document.getElementById('reminderEnabled');
    const note = document.getElementById('reminderNeedsDeadline');
    if (!picker) return;
    picker.style.opacity = on ? '' : '.5';
    picker.style.pointerEvents = on ? '' : 'none';
    if (chk) chk.disabled = !on;
    if (note) note.style.display = on ? 'none' : 'block';
    if (!on && chk) { chk.checked = false; const r = document.getElementById('reminderRules'); if (r) r.style.display = 'none'; }
}
window.setReminderPickerEnabled = setReminderPickerEnabled;

function addReminderRule() {
    const list = document.getElementById('reminderRulesList');
    if (!list) return;
    const tmp = document.createElement('div');
    tmp.innerHTML = _reminderRuleRow(60);
    list.appendChild(tmp.firstElementChild);
}
window.addReminderRule = addReminderRule;

/* 8.16-3 (31 oct. 2026): selectorul de mementouri (în ferestrele de sondaj, „Ce jucăm" și
   eveniment) fără handlere inline — delegare pe `document`, pe CAPTURĂ, ca la sondaje. Același
   efect ca înainte: ✕ scoate rândul, „+" adaugă unul, bifa arată / ascunde lista.
   EN: reminder picker without inline handlers; same effects. */
(function () {
    function onClick(e) {
        var el = e.target && e.target.closest ? e.target.closest('[data-action="rem-del"],[data-action="rem-add"]') : null;
        if (!el) return;
        if (el.getAttribute('data-action') === 'rem-del') { if (el.parentElement) el.parentElement.remove(); }
        else addReminderRule();
    }
    function onChange(e) {
        var el = e.target;
        if (!el || !el.matches || !el.matches('[data-action="rem-toggle"]')) return;
        var r = document.getElementById('reminderRules');
        if (r) r.style.display = el.checked ? 'block' : 'none';
    }
    if (!document.__toRemActs) {
        document.__toRemActs = true;
        document.addEventListener('click', onClick, true);
        document.addEventListener('change', onChange, true);
    }
})();

/* Citește config-ul din formular -> { enabled, rules:[{offset}] } (dedup, sortat). */
function readReminderConfig() {
    const en = document.getElementById('reminderEnabled');
    if (!en || !en.checked) return { enabled: false, rules: [] };
    const seen = {};
    const rules = Array.prototype.slice.call(document.querySelectorAll('#reminderRulesList .reminder-offset'))
        .map(sel => Number(sel.value) || 0)
        .filter(v => v > 0 && !seen[v] && (seen[v] = 1))
        .sort((a, b) => b - a)
        .map(offset => ({ offset }));
    return { enabled: rules.length > 0, rules };
}
window.readReminderConfig = readReminderConfig;

/* Default-urile de remindere ale clubului (decizia C) — setate de admin în
   Settings, pre-populează formularele de creare. Cad pe un default rezonabil
   dacă nu sunt configurate. `kind` = 'event' | 'poll' | 'gamevote'. */
function _clubReminderDefaults(kind) {
    try {
        const d = (state.settings && state.settings.reminderDefaults) || {};
        if (d[kind] && typeof d[kind] === 'object') return d[kind];
    } catch (e) { logError('_clubReminderDefaults', e); }
    /* Default de sistem: activat, cu 1 zi înainte. */
    return { enabled: true, rules: [{ offset: 1440 }] };
}
window._clubReminderDefaults = _clubReminderDefaults;

/* ============================================================
   v8 — LIMITĂ DE LOCURI (câmp de formular reutilizat la adăugare ȘI la editare)
   RO: un spațiu fizic are un număr finit de locuri, dar aplicația promitea RSVP
       nelimitat. Gol = fără limită = EXACT comportamentul dinainte de v8, deci
       evenimentele existente nu se schimbă cu nimic. Coloana din baza de date
       (`events.max_participants`) exista deja și era nefolosită (0 rânduri) —
       o refolosim în loc să adăugăm o a doua coloană cu același înțeles.
   EN: physical rooms have a finite number of seats. Empty = no limit = exact
       pre-v8 behaviour. Reuses the pre-existing, unused `max_participants`
       column rather than introducing a second one meaning the same thing.
   ============================================================ */
function _eventCapacityFieldHtml(current) {
    var val = (current != null && current !== '') ? String(parseInt(current, 10) || '') : '';
    return `
            <div class="form-group">
                <label for="eventCapacity"><i class="fas fa-user-group"></i> ${t('ev.seatLimit')}</label>
                <input type="number" id="eventCapacity" class="form-control" min="1" max="9999"
                       inputmode="numeric" value="${val}" placeholder="${t('ev.seatLimitPh')}">
                <small style="color:var(--text-secondary);">${t('ev.seatLimitHint')}</small>
            </div>
`;
}
window._eventCapacityFieldHtml = _eventCapacityFieldHtml;

/* v9 8.16-4f (1 nov. 2026): `opts.onCreated(event)` (opțional, din chat) — saveEvent îl cheamă cu primul
   eveniment creat, DUPĂ ce serverul l-a acceptat (chatul îl atașează ca un card). Legat de ACEASTĂ
   fereastră (`modal.__onCreated`). Apelurile vechi (2 parametri) rămân identice. */
function addEventModal(dateStr = '', prefill = null, opts) {
    const existingAdd = document.getElementById('addEventModal'); if (existingAdd) existingAdd.remove();
    const modal = document.createElement('div');
    modal.className = 'modal active';
    modal.id = 'addEventModal';
    
    const defaultDate = dateStr || new Date().toISOString().split('T')[0];
    const defaultTime = new Date().toTimeString().slice(0, 5);
    
    modal.innerHTML = `
        <div class="modal-content">
            <div class="modal-header">
                <h2><i class="fas fa-plus"></i> ${t('event.addTitle')}</h2>
                <button class="modal-close" data-ev-act="close" aria-label="${t('common.close')}">×</button>
            </div>
            
            <div class="form-group">
                <label for="eventTitle"><i class="fas fa-heading"></i> ${t('event.eTitle')}</label>
                <input type="text" id="eventTitle" class="form-control" placeholder="${t('event.eTitlePh')}">
            </div>
            
            <div class="form-row">
                <div class="form-group">
                    <label for="eventDate"><i class="fas fa-calendar"></i> ${t('event.date')}</label>
                    <input type="date" id="eventDate" class="form-control" value="${defaultDate}">
                </div>
                <div class="form-group">
                    <label for="eventTime"><i class="fas fa-clock"></i> ${t('event.time')}</label>
                    <input type="time" id="eventTime" class="form-control" value="${defaultTime}">
                </div>
            </div>
            
            <div class="form-group">
                <label for="eventLocation"><i class="fas fa-map-marker-alt"></i> ${t('event.location')}</label>
                <input type="text" id="eventLocation" class="form-control" placeholder="${t('event.locationPh')}">
            </div>
            
            <div class="form-group">
                <label for="eventType"><i class="fas fa-tag"></i> ${t('event.type')}</label>
                <select id="eventType" class="form-control">
                    <option value="session">${t('event.typeSession')}</option>
                    <option value="tournament">${t('event.typeTournament')}</option>
                    <option value="meeting">${t('event.typeMeeting')}</option>
                    <option value="other">${t('event.typeOther')}</option>
                </select>
            </div>
            
            <div class="form-group">
                <label for="eventDescription"><i class="fas fa-align-left"></i> ${t('event.description')}</label>
                <textarea id="eventDescription" class="form-control" rows="3" placeholder="${t('event.descriptionPh')}"></textarea>
            </div>

            ${(typeof can === 'function' && can('event.manage')) ? _eventCapacityFieldHtml(null) : ''}

            <div class="form-row">
                <div class="form-group">
                    <label for="eventRecurrence"><i class="fas fa-repeat"></i> ${t('event.recurrence')}</label>
                    <select id="eventRecurrence" class="form-control">
                        <option value="none">${t('event.recOnce')}</option>
                        <option value="weekly">${t('event.recWeekly')}</option>
                        <option value="biweekly">${t('event.recBiweekly')}</option>
                        <option value="monthly">${t('event.recMonthly')}</option>
                    </select>
                </div>
                <div class="form-group" id="recurrenceCountRow" style="display:none;">
                    <label for="eventRecurrenceCount"><i class="fas fa-hashtag"></i> ${t('event.recCount')}</label>
                    <input type="number" id="eventRecurrenceCount" class="form-control" value="8" min="2" max="52">
                </div>
            </div>

            ${reminderPickerHTML(_clubReminderDefaults('event'))}
            
            <div class="btn-group">
                <button class="btn btn-success" data-ev-act="save">
                    <i class="fas fa-save"></i> ${t('event.save')}
                </button>
                <button class="btn btn-secondary" data-ev-act="close">
                    <i class="fas fa-times"></i> ${t('common.cancel')}
                </button>
            </div>
        </div>
    `;
    
    /* v9 8.16-4f: fără handlere inline — ✕ / Anulează / Salvează și recurența, pe fereastră. */
    if (opts && typeof opts.onCreated === 'function') modal.__onCreated = opts.onCreated;
    modal.addEventListener('click', function (e) {
        const el = e.target && e.target.closest ? e.target.closest('[data-ev-act]') : null;
        if (!el || !modal.contains(el)) return;
        const a = el.getAttribute('data-ev-act');
        if (a === 'close') modal.remove();
        else if (a === 'save' && typeof saveEvent === 'function') saveEvent();
    });
    const _rec = modal.querySelector('#eventRecurrence');
    if (_rec) _rec.addEventListener('change', function () {
        const row = modal.querySelector('#recurrenceCountRow');
        if (row) row.style.display = (_rec.value === 'none' ? 'none' : 'block');
    });
    document.body.appendChild(modal);

    /* §4 — Pre-populare din rezultatul unui poll / vot de joc.
       Aplicată DUPĂ randare (fără chirurgie pe template). Userul vede formularul
       normal și CONFIRMĂ — nu creăm nimic „prin magie" în spate. */
    if (prefill && typeof prefill === 'object') {
        const setVal = (id, v) => { const el = modal.querySelector('#' + id); if (el && v != null && v !== '') el.value = v; };
        setVal('eventTitle', prefill.title);
        setVal('eventDate', prefill.date);
        setVal('eventTime', prefill.time);
        setVal('eventLocation', prefill.location);
        setVal('eventType', prefill.type);
        setVal('eventDescription', prefill.description);
        if (prefill.notice) showNotification(prefill.notice, 'info');
    }
}
window.addEventModal = addEventModal;

/* ============================================================
   §4 — PUNTE: Poll / Vot de joc  ->  Eveniment (RSVP curge normal după).
   Gating: crearea evenimentului e Moderator+ (`can('event.manage')`), la fel ca
   `saveEvent`. Butoanele nici nu se afișează dacă nu ai dreptul.
   ============================================================ */
function canCreateEventFromResult() {
    if (typeof can === 'function') return can('event.manage');
    return (typeof isAdmin !== 'undefined' && isAdmin);
}
window.canCreateEventFromResult = canCreateEventFromResult;

/* Parsare best-effort a unei date/ore dintr-o opțiune de poll cu text LIBER
   (ex. „Vineri 18 iulie, ora 19:00", „18.07 la 19", „2026-07-18 19:30").
   Întoarce { date:'YYYY-MM-DD', time:'HH:MM' } — câmpurile negăsite lipsesc.
   NU ghicim agresiv: ce nu recunoaștem rămâne pe seama userului, în formular. */
const _EVT_MONTHS = {
    ian: 0, ianuarie: 0, jan: 0, january: 0,
    feb: 1, februarie: 1, february: 1,
    mar: 2, martie: 2, march: 2,
    apr: 3, aprilie: 3, april: 3,
    mai: 4, may: 4,
    iun: 5, iunie: 5, jun: 5, june: 5,
    iul: 6, iulie: 6, jul: 6, july: 6,
    aug: 7, august: 7,
    sep: 8, septembrie: 8, september: 8,
    oct: 9, octombrie: 9, october: 9,
    noi: 10, noiembrie: 10, nov: 10, november: 10,
    dec: 11, decembrie: 11, december: 11
};

function parseDateTimeFromText(text) {
    const s = String(text || '').toLowerCase().trim();
    if (!s) return {};
    const out = {};
    const pad = n => String(n).padStart(2, '0');
    const now = new Date();

    /* --- ORA: „19:30" sau „ora 19" / „la 19" / „at 19".
       ATENȚIE: acceptăm DOAR „:" ca separator de oră. Punctul e ambiguu — „18.07"
       e o DATĂ (18 iulie), nu ora 18:07. Ce nu recunoaștem sigur, lăsăm userului. */
    let hh = null, mm = 0;
    let m = s.match(/(\d{1,2})\s*:\s*(\d{2})/);
    if (m) { hh = parseInt(m[1], 10); mm = parseInt(m[2], 10); }
    else {
        m = s.match(/(?:ora|la|at)\s+(\d{1,2})(?!\s*[.\/:-]?\s*\d)/);
        if (m) { hh = parseInt(m[1], 10); mm = 0; }
    }
    if (hh != null && hh >= 0 && hh <= 23 && mm >= 0 && mm <= 59) out.time = pad(hh) + ':' + pad(mm);

    /* --- DATA (ISO): „2026-07-18" --- */
    m = s.match(/(\d{4})-(\d{2})-(\d{2})/);
    if (m) { out.date = `${m[1]}-${m[2]}-${m[3]}`; return out; }

    /* --- DATA numerică: „18.07", „18/07/2026", „18-07" --- */
    m = s.match(/(\d{1,2})\s*[.\/-]\s*(\d{1,2})(?:\s*[.\/-]\s*(\d{2,4}))?/);
    if (m) {
        const day = parseInt(m[1], 10);
        const mon = parseInt(m[2], 10) - 1;
        let year = m[3] ? parseInt(m[3], 10) : now.getFullYear();
        if (year < 100) year += 2000;
        if (day >= 1 && day <= 31 && mon >= 0 && mon <= 11) {
            /* Fără an explicit și data a trecut deja -> presupunem anul viitor. */
            let d = new Date(year, mon, day);
            if (!m[3] && d < new Date(now.getFullYear(), now.getMonth(), now.getDate())) d = new Date(year + 1, mon, day);
            out.date = `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
            return out;
        }
    }

    /* --- DATA cu lună în litere: „18 iulie", „july 18" --- */
    const monKeys = Object.keys(_EVT_MONTHS).sort((a, b) => b.length - a.length);
    for (const k of monKeys) {
        const re = new RegExp('(?:(\\d{1,2})\\s*(?:de\\s+)?' + k + '|' + k + '\\s*(\\d{1,2}))(?:\\D+(\\d{4}))?');
        const mm2 = s.match(re);
        if (!mm2) continue;
        const day = parseInt(mm2[1] || mm2[2], 10);
        if (!(day >= 1 && day <= 31)) continue;
        const mon = _EVT_MONTHS[k];
        const year = mm2[3] ? parseInt(mm2[3], 10) : now.getFullYear();
        let d = new Date(year, mon, day);
        if (!mm2[3] && d < new Date(now.getFullYear(), now.getMonth(), now.getDate())) d = new Date(year + 1, mon, day);
        out.date = `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
        return out;
    }
    return out;
}
window.parseDateTimeFromText = parseDateTimeFromText;

/* Creează un eveniment din rezultatul unui POLL încheiat (opțiunea câștigătoare). */
function eventFromPoll(pollId) {
    if (!canCreateEventFromResult()) { showNotification(t('rbac.noPermission'), 'error'); return; }
    const poll = (state.polls || []).find(p => String(p.id) === String(pollId));
    if (!poll) { showNotification(t('ev.pollNotFound'), 'error'); return; }

    const opts = Array.isArray(poll.options) ? poll.options : [];
    const winner = opts.reduce((best, o) =>
        ((o.votes || []).length > (best ? (best.votes || []).length : -1)) ? o : best, null);
    if (!winner || !(winner.votes || []).length) { showNotification(t('ev.noVotesToUse'), 'error'); return; }

    /* Opțiunile sunt TEXT LIBER -> încercăm să extragem data/ora; ce nu găsim,
       completează userul în formular (fără magie, §4). */
    const parsed = parseDateTimeFromText(winner.text);
    const desc = t('ev.fromPollDesc')
        .replace('{q}', poll.question || '')
        .replace('{opt}', winner.text || '')
        .replace('{n}', (winner.votes || []).length);

    addEventModal(parsed.date || '', {
        title: poll.question || winner.text,
        date: parsed.date,
        time: parsed.time,
        description: desc,
        type: 'meeting',
        notice: parsed.date ? t('ev.prefilledFromPoll') : t('ev.pickDateYourself')
    });
}
window.eventFromPoll = eventFromPoll;

/* Creează un eveniment din rezultatul unui VOT DE JOC încheiat (jocul câștigător). */
function eventFromGameVote(winnerTitle) {
    if (!canCreateEventFromResult()) { showNotification(t('rbac.noPermission'), 'error'); return; }
    const game = String(winnerTitle || '').trim();
    if (!game) { showNotification(t('ev.noVotesToUse'), 'error'); return; }
    addEventModal('', {
        title: t('ev.fromGameVoteTitle').replace('{game}', game),
        description: t('ev.fromGameVoteDesc').replace('{game}', game),
        type: 'session',
        notice: t('ev.pickDateYourself')
    });
}
window.eventFromGameVote = eventFromGameVote;

/* NOTĂ (Override Map §5): versiunea REALĂ folosită la runtime e `saveEvent` din
   supabase-integration.js (se încarcă după acest fișier). Asta rămâne fallback-ul
   local/demo. Orice modificare funcțională se face în supabase-integration.js. */
function saveEvent() {
    const title = document.getElementById('eventTitle').value.trim();
    const date = document.getElementById('eventDate').value;
    const time = document.getElementById('eventTime').value;
    const location = document.getElementById('eventLocation').value.trim();
    const type = document.getElementById('eventType').value;
    const description = document.getElementById('eventDescription').value.trim();
    
    if (!title || !date || !time) {
        showNotification(t('m2.fillTitleDateTime'), 'error');
        return;
    }
    
    // Create event
    const event = {
        id: 'event-' + Date.now(),
        title,
        date: new Date(`${date}T${time}`).toISOString(),
        location: location || null,
        type,
        description: description || null,
        organizer: state.currentUser.name,
        participants: [],
        createdAt: new Date().toISOString()
    };
    
    // Add to events
    state.events.push(event);
    
    // Save and update
    saveState();
    renderCalendar();
    
    // Close modal
    document.querySelector('.modal.active').remove();
    
    // Add audit log
    addAuditLog('audit.eventCreated', state.currentUser.name, title);
    
    // Add notifications for all users
    Object.keys(state.users).forEach(email => {
        if (email !== state.currentUser.email) {
            addUserNotification(email, 'event', `${state.currentUser.name} a creat evenimentul: ${title}`);
        }
    });
    
    showNotification(t('m2.eventCreated'), 'success');
}

// Format a Date as a UTC iCalendar timestamp: YYYYMMDDTHHMMSSZ
function toICSDate(d) {
    const p = n => String(n).padStart(2, '0');
    return d.getUTCFullYear() + p(d.getUTCMonth() + 1) + p(d.getUTCDate()) +
        'T' + p(d.getUTCHours()) + p(d.getUTCMinutes()) + p(d.getUTCSeconds()) + 'Z';
}

// Escape text per RFC 5545
function icsEscape(text) {
    return String(text == null ? '' : text)
        .replace(/\\/g, '\\\\').replace(/;/g, '\\;')
        .replace(/,/g, '\\,').replace(/\n/g, '\\n');
}

function exportCalendar() {
    const events = state.events || [];
    if (events.length === 0) {
        showNotification(t('m2.noEventsExport'), 'warning');
        return;
    }

    const now = toICSDate(new Date());
    let ics = [
        'BEGIN:VCALENDAR',
        'VERSION:2.0',
        'PRODID:-//TurnOrder//' + clubDisplayName() + '//RO',
        'CALSCALE:GREGORIAN',
        'METHOD:PUBLISH',
        'X-WR-CALNAME:' + clubDisplayName() + ' Evenimente'
    ];

    events.forEach(ev => {
        const start = new Date(ev.date);
        if (isNaN(start)) return;
        // Default duration: 2 hours
        const end = new Date(start.getTime() + 2 * 60 * 60 * 1000);
        ics.push('BEGIN:VEVENT');
        ics.push('UID:' + (ev.id || 'evt-' + start.getTime()) + '@gbgsc');
        ics.push('DTSTAMP:' + now);
        ics.push('DTSTART:' + toICSDate(start));
        ics.push('DTEND:' + toICSDate(end));
        ics.push('SUMMARY:' + icsEscape(ev.title));
        if (ev.location) ics.push('LOCATION:' + icsEscape(ev.location));
        const descParts = [];
        if (ev.description) descParts.push(ev.description);
        if (ev.organizer) descParts.push('Organizator: ' + ((typeof displayNameById === 'function' && displayNameById(ev.organizer)) || ev.organizer));
        if (ev.type) descParts.push('Tip: ' + ev.type);
        if (descParts.length) ics.push('DESCRIPTION:' + icsEscape(descParts.join('\n')));
        ics.push('END:VEVENT');
    });

    ics.push('END:VCALENDAR');

    // .ics lines should be CRLF-terminated
    const blob = new Blob([ics.join('\r\n')], { type: 'text/calendar;charset=utf-8' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `turnorder-calendar-${new Date().toISOString().split('T')[0]}.ics`;
    link.click();
    URL.revokeObjectURL(url);

    if (state.currentUser) addAuditLog('audit.exportCalendarIcs', state.currentUser.name);
    showNotification(t('m2.calendarExported').replace('{count}', events.length), 'success');
}

/* ⚡ PERFORMANȚĂ (§54, aug. 2026) — cele două iconițe de mai jos erau `fab fa-google`.
   RO: familia „brands" a Font Awesome era folosită în TOT proiectul de doar 3 ori
       (2 aici + 1 WhatsApp), dar prezența ei obliga browserul să descarce
       `fa-brands-400.woff2` (~108 kB) la FIECARE pornire — inclusiv pentru userii
       care nu deschid niciodată acest modal. Trecute pe familia „solid", deja
       încărcată pentru celelalte ~1.180 de iconițe. Textul „Google Calendar" rămâne
       scris în titlu, deci recunoașterea vizuală nu se pierde.
   EN: the Font Awesome "brands" family was used exactly 3 times project-wide, yet it
       forced a ~108 kB webfont download on every startup. Moved to the already-loaded
       "solid" family; the words "Google Calendar" stay in the heading. */
function syncWithGoogleCalendar() {
    const events = (state.events || [])
        .filter(ev => new Date(ev.date) >= new Date(Date.now() - 24 * 60 * 60 * 1000))
        .sort((a, b) => new Date(a.date) - new Date(b.date));

    const esc = (s) => String(s == null ? '' : s)
        .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');

    const fmt = d => {
        const p = n => String(n).padStart(2, '0');
        return d.getUTCFullYear() + p(d.getUTCMonth() + 1) + p(d.getUTCDate()) +
            'T' + p(d.getUTCHours()) + p(d.getUTCMinutes()) + p(d.getUTCSeconds()) + 'Z';
    };

    const rows = events.map(ev => {
        const start = new Date(ev.date);
        const end = new Date(start.getTime() + 2 * 60 * 60 * 1000);
        const params = new URLSearchParams({
            action: 'TEMPLATE',
            text: ev.title || ('Eveniment ' + clubDisplayName()),
            dates: `${fmt(start)}/${fmt(end)}`,
            details: [ev.description, ev.organizer ? 'Organizator: ' + ((typeof displayNameById === 'function' && displayNameById(ev.organizer)) || ev.organizer) : '']
                .filter(Boolean).join('\n'),
            location: ev.location || ''
        });
        const gUrl = 'https://calendar.google.com/calendar/render?' + params.toString();
        return `
            <div style="display:flex; justify-content:space-between; align-items:center; gap:12px;
                        padding:12px; background:var(--bg-secondary); border-radius:8px; margin-bottom:10px;">
                <div>
                    <div style="font-weight:bold;">${esc(ev.title)}</div>
                    <small style="color:var(--text-secondary);">
                        ${start.toLocaleDateString('en-GB')} ${start.toLocaleTimeString(appTimeLocale(), {hour:'2-digit', minute:'2-digit'})}
                        ${ev.location ? '• ' + esc(ev.location) : ''}
                    </small>
                </div>
                <a href="${esc(gUrl)}" target="_blank" rel="noopener" class="btn btn-sm" style="white-space:nowrap; text-decoration:none;">
                    <i class="fas fa-calendar-plus"></i> ${t('event.create')}
                </a>
            </div>`;
    }).join('');

    const modal = document.createElement('div');
    modal.className = 'modal active';
    modal.innerHTML = `
        <div class="modal-content" style="max-width:600px;">
            <div class="modal-header">
                <h2><i class="fas fa-calendar-alt"></i> Google Calendar</h2>
                <button class="modal-close" data-cal-act="close" aria-label="${t('common.close')}">×</button>
            </div>
            <p style="color:var(--text-secondary); margin-bottom:16px;">
                ${t('cal.googleHelp')}
            </p>
            ${events.length ? rows : `<p class="text-center text-muted">${t('cal.noUpcoming')}</p>`}
            <div class="btn-group mt-20">
                <button class="btn" data-cal-act="export">
                    <i class="fas fa-file-export"></i> Export .ics (toate)
                </button>
                <button class="btn btn-secondary" data-cal-act="close">
                    <i class="fas fa-times"></i> ${t('common.close')}
                </button>
            </div>
        </div>`;
    document.body.appendChild(modal);
}

/* ================= STATISTICS ================= */
function renderStats() {
    updateStats();
}

let statsType = 'overview';
window.statsType = 'overview';
function setStatsType(type, btn) {
    statsType = type;
    window.statsType = type;
    const tabs = document.getElementById('statsTabs');
    if (tabs) tabs.querySelectorAll('.sess-tile').forEach(b => b.classList.remove('is-active'));
    if (btn) btn.classList.add('is-active');
    updateStats();
}
window.setStatsType = setStatsType;

function toggleStatsFilters() {
    const panel = document.getElementById('statsFiltersPanel');
    const btn = document.getElementById('statsFilterToggle');
    if (!panel) return;
    const open = panel.classList.toggle('hidden') === false;
    if (btn) btn.classList.toggle('is-on', open);
}
window.toggleStatsFilters = toggleStatsFilters;

/* Show-more reutilizabil pentru tabele stats (>5 rânduri) */
let _statsMore = {};
function statsMoreBtn(key, total, shown) {
    if (total <= shown) return '';
    _statsMore[key] = false;
    return `<div class="stats-more-wrap" id="moreWrap_${key}"><button type="button" class="btn btn-sm btn-secondary players-more-btn" onclick="toggleStatsMore('${key}')"><i class="fas fa-chevron-down"></i> ${t('players.showMore')} (${total - shown})</button></div>`;
}
function toggleStatsMore(key) {
    _statsMore[key] = !_statsMore[key];
    const exp = _statsMore[key];
    document.querySelectorAll('[data-more="' + key + '"]').forEach(r => r.classList.toggle('stats-hidden', !exp));
    const wrap = document.getElementById('moreWrap_' + key);
    if (wrap) {
        const b = wrap.querySelector('button');
        if (b) b.innerHTML = exp
            ? `<i class="fas fa-chevron-up"></i> ${t('players.showLess')}`
            : `<i class="fas fa-chevron-down"></i> ${t('players.showMore')}`;
    }
}
window.toggleStatsMore = toggleStatsMore;

function updateStats() {
    const period = document.getElementById('statsPeriod').value;
    const type = statsType;
    
    const container = document.getElementById('statsContent');

    // ELO leaderboard apare DOAR pe Overview (nu mai bruiază celelalte tab-uri)
    const eloEl = document.getElementById('eloLeaderboard');
    if (eloEl) {
        if (type === 'overview' && typeof renderEloLeaderboard === 'function') {
            renderEloLeaderboard();
        } else {
            eloEl.innerHTML = '';
            eloEl.style.display = 'none';
        }
    }
    
    switch(type) {
        case 'overview':
            renderOverviewStats(container, period);
            break;
        case 'players':
            renderPlayerStats(container, period);
            break;
        case 'games':
            renderGameStats(container, period);
            break;
        case 'trends':
            renderTrendStats(container, period);
            break;
        case 'hindex':
            renderHIndexStats(container, period);
            break;
        case 'rolewinrate':
            renderRoleWinRateStats(container, period);
            break;
        case 'coop':
            renderCoopStats(container, period);
            break;
    }
}

function renderOverviewStats(container, period) {
    const stats = calculatePeriodStats(period);
    
    container.innerHTML = `
        <div class="stats-grid">
            <div class="stat-card">
                <div class="stat-label">${t('stats.sessions')}</div>
                <div class="stat-value">${stats.totalSessions}</div>
                <div class="stat-change ${stats.sessionChange >= 0 ? 'positive' : 'negative'}">
                    ${stats.sessionChange >= 0 ? '+' : ''}${stats.sessionChange}%
                </div>
            </div>
            <div class="stat-card">
                <div class="stat-label">${t('stats.uniquePlayers')}</div>
                <div class="stat-value">${stats.uniquePlayers}</div>
            </div>
            <div class="stat-card">
                <div class="stat-label">${t('stats.pointsAccrued')}</div>
                <div class="stat-value">${stats.totalPoints}</div>
            </div>
            <div class="stat-card">
                <div class="stat-label">${t('stats.totalDuration')}</div>
                <div class="stat-value">${stats.totalHours}h</div>
            </div>
        </div>
    `;
}

/* ---- Statistici Co-op dedicate (Faza 3): calculate client-side din state.games ---- */
function renderCoopStats(container, period) {
    const periodGames = (typeof getGamesByPeriod === 'function') ? getGamesByPeriod(period) : (state.games || []);
    const _co = g => (g && ((g.meta && g.meta.coop) || g.coop)) || null;
    const coop = periodGames.filter(g => g.type === 'coop' || !!_co(g));
    if (!coop.length) {
        container.innerHTML = `<p class="text-center text-muted" style="padding:20px;">${t('coopStats.empty')}</p>`;
        return;
    }
    const DIFF_RANK = { easy: 1, normal: 2, hard: 3, heroic: 4, brutal: 5 };
    let wins = 0, losses = 0;
    const byDiff = {};            /* slug -> {wins,total} */
    const gameCount = {};         /* gameName -> plays */
    let hardestWin = null;        /* {rank,label} */
    coop.forEach(g => {
        const c = _co(g) || {};
        const out = c.outcome || '';
        if (out === 'win') wins++; else if (out === 'loss') losses++;
        const d = c.difficulty || 'none';
        (byDiff[d] = byDiff[d] || { wins: 0, total: 0 }).total++;
        if (out === 'win') byDiff[d].wins++;
        if (g.gameName) gameCount[g.gameName] = (gameCount[g.gameName] || 0) + 1;
        if (out === 'win' && DIFF_RANK[c.difficulty]) {
            const rank = DIFF_RANK[c.difficulty];
            if (!hardestWin || rank > hardestWin.rank) {
                hardestWin = { rank, label: (typeof coopDifficultyText === 'function') ? coopDifficultyText(c) : c.difficulty };
            }
        }
    });
    const total = coop.length;
    const decided = wins + losses;
    const winRate = decided ? Math.round(wins / decided * 100) : 0;
    /* Serie curentă de victorii (de la cea mai recentă în urmă). */
    let streak = 0;
    coop.slice().sort((a, b) => new Date(b.timestamp || 0) - new Date(a.timestamp || 0))
        .some(g => { const out = (_co(g) || {}).outcome || ''; if (out === 'win') { streak++; return false; } return true; });
    const mostPlayed = Object.entries(gameCount).sort((a, b) => b[1] - a[1])[0] || null;
    const DIFF_ORDER = ['easy', 'normal', 'hard', 'heroic', 'brutal', 'custom', 'none'];
    const diffRows = DIFF_ORDER.filter(d => byDiff[d]).map(d => ({
        label: t('coop.diff.' + d), wins: byDiff[d].wins, total: byDiff[d].total
    }));

    container.innerHTML = `
        <div class="stats-grid">
            <div class="stat-card"><div class="stat-label">${t('coopStats.sessions')}</div><div class="stat-value">${total}</div></div>
            <div class="stat-card"><div class="stat-label">${t('coopStats.wins')}</div><div class="stat-value">${wins}</div></div>
            <div class="stat-card"><div class="stat-label">${t('coopStats.winRate')}</div><div class="stat-value">${winRate}%</div></div>
            <div class="stat-card"><div class="stat-label">${t('coopStats.streak')}</div><div class="stat-value">${streak}</div></div>
            <div class="stat-card"><div class="stat-label">${t('coopStats.hardestBeaten')}</div><div class="stat-value" style="font-size:1.05em;">${hardestWin ? clubEsc(String(hardestWin.label)) : '—'}</div></div>
            <div class="stat-card"><div class="stat-label">${t('coopStats.mostPlayed')}</div><div class="stat-value" style="font-size:1.05em;">${mostPlayed ? clubEsc(mostPlayed[0]) + ' <small style="opacity:.6;">(' + mostPlayed[1] + ')</small>' : '—'}</div></div>
        </div>
        <h3 style="margin:20px 0 10px; font-size:1.05em;"><i class="fas fa-gauge-high"></i> ${t('coopStats.byDifficulty')}</h3>
        <div class="table-responsive"><table>
            <thead><tr><th>${t('coop.difficultyShort')}</th><th>${t('coopStats.wins')}</th><th>${t('coopStats.sessions')}</th><th>${t('coopStats.winRate')}</th></tr></thead>
            <tbody>
            ${diffRows.map(r => `<tr><td>${clubEsc(r.label)}</td><td>${r.wins}</td><td>${r.total}</td><td>${r.total ? Math.round(r.wins / r.total * 100) : 0}%</td></tr>`).join('')}
            </tbody>
        </table></div>
    `;
}
window.renderCoopStats = renderCoopStats;

function calculatePeriodStats(period) {
    const now = new Date();
    let startDate;
    
    switch(period) {
        /* RO: `now.setX(...)` MUTA obiectul `now`, apoi îl împachetează într-un
               Date nou — deci după `switch` variabila nu mai înseamnă „acum".
               În plus, `setMonth` fără limitare aluneca cu 1–3 zile în zilele de
               29–31, iar `setFullYear` pe 29 februarie sărea în 1 martie.
               `addMonths`/`addDays` nu ating originalul și limitează ziua.
           EN: the old code mutated `now` and overflowed on month ends. */
        case 'week':
            startDate = addDays(now, -7);
            break;
        case 'month':
            startDate = addMonths(now, -1);
            break;
        case 'quarter':
            startDate = addMonths(now, -3);
            break;
        case 'year':
            startDate = addYears(now, -1);
            break;
        default: // 'all'
            startDate = new Date(0);
    }
    
    // Filter games by period
    const periodGames = state.games.filter(game => 
        new Date(game.timestamp) >= startDate
    );
    
    // Calculate stats
    const totalSessions = periodGames.length;
    const uniquePlayers = new Set(
        periodGames.flatMap(game => game.participants || [])
    ).size;
    const totalPoints = periodGames.reduce((sum, game) => 
        sum + Object.values(game.scores || {}).reduce((s, v) => s + (Number(v) || 0), 0), 0
    );
    const totalDuration = periodGames.reduce((sum, game) => sum + (game.duration || 0), 0);
    const totalHours = Math.round(totalDuration / 60);
    
    // Calculate session change compared to previous period
    const prevStartDate = new Date(startDate.getTime() - (now.getTime() - startDate.getTime()));
    const prevPeriodGames = state.games.filter(game => 
        new Date(game.timestamp) >= prevStartDate && new Date(game.timestamp) < startDate
    );
    const prevSessions = prevPeriodGames.length;
    const sessionChange = prevSessions > 0 ? 
        Math.round(((totalSessions - prevSessions) / prevSessions) * 100) : 0;
    
    return {
        totalSessions,
        uniquePlayers,
        totalPoints: totalPoints.toFixed(1),
        totalHours,
        sessionChange
    };
}

/* ---------- Statistici inter-club (plan Elite+) ----------
   Agregă datele jucătorului curent din TOATE cluburile în care e membru. */
async function openCrossClubStats() {
    if (!requireFeature('crossClubStats')) return;
    const myName = state.currentUser ? state.currentUser.name : null;
    const myId = state.currentUser ? state.currentUser.id : null;
    const clubs = (state.myClubs || []);
    const ids = clubs.map(c => c.id);
    const modal = document.createElement('div');
    modal.className = 'modal active';
    modal.innerHTML = `<div class="modal-content"><div class="modal-header">
        <h2><i class="fas fa-layer-group"></i> ${t('stats.crossClubTitle')}</h2>
        <button class="modal-close" onclick="this.closest('.modal').remove()">×</button></div>
        <div id="crossClubBody"><p style="opacity:.7;">${t('cross.loading').replace('{n}', ids.length)}</p></div></div>`;
    document.body.appendChild(modal);
    const body = modal.querySelector('#crossClubBody');
    if (!myId || !ids.length) { body.innerHTML = '<p style="opacity:.7;">' + t('cross.notEnoughData') + '</p>'; return; }

    let rows = [];
    try {
        const res = await sb.from('matches').select('club_id, game_title, players, scores, winners, meta').in('club_id', ids);
        if (res.error) throw res.error;
        rows = res.data || [];
    } catch (e) { body.innerHTML = `<p style="color:#e07a5f;">${t('cross.loadError')}: ${clubEsc((e && e.message) || '')}</p>`; return; }

    const clubName = {}; clubs.forEach(c => clubName[c.id] = c.name);
    const perClub = {}, gameCounts = {};
    let totalSessions = 0, totalWins = 0, totalPoints = 0;
    rows.forEach(m => {
        const meta = sbObject(m.meta) || {};
        if (meta.friendly) return; /* amicalele NU contează la stats jucători (§12.d) — aliniat cu clubul activ */
        const players = sbArray(m.players) || []; if (players.indexOf(myId) === -1) return;
        const winners = sbArray(m.winners) || []; const scores = sbObject(m.scores) || {};
        const pc = perClub[m.club_id] || (perClub[m.club_id] = { sessions: 0, wins: 0, points: 0 });
        pc.sessions++; totalSessions++;
        if (winners.indexOf(myId) !== -1) { pc.wins++; totalWins++; }
        const pts = Number(scores[myId]) || 0; pc.points += pts; totalPoints += pts;
        const gn = m.game_title || 'Joc'; gameCounts[gn] = (gameCounts[gn] || 0) + 1;
    });

    if (!totalSessions) { body.innerHTML = '<p style="opacity:.7;">' + t('cross.noSessions') + '</p>'; return; }
    const winRate = Math.round(totalWins / totalSessions * 100);
    const distinctGames = Object.keys(gameCounts).length;
    const topGames = Object.keys(gameCounts).map(g => [g, gameCounts[g]]).sort((a, b) => b[1] - a[1]).slice(0, 5);
    const clubRows = Object.keys(perClub).map(id => {
        const p = perClub[id];
        return { name: clubName[id] || 'Club', sessions: p.sessions, wins: p.wins, points: p.points, rate: p.sessions ? Math.round(p.wins / p.sessions * 100) : 0 };
    }).sort((a, b) => b.sessions - a.sessions);

    body.innerHTML = `
        <p style="color:var(--text-secondary); font-size:0.85em;">${t('cross.aggregatedFor').replace('{name}', `<strong>${clubEsc(myName)}</strong>`).replace('{n}', clubRows.length)}</p>
        <div class="stats-grid">
            <div class="stat-card"><div class="stat-label">${t('stats.clubs')}</div><div class="stat-value">${clubRows.length}</div></div>
            <div class="stat-card"><div class="stat-label">${t('stats.sessions')}</div><div class="stat-value">${totalSessions}</div></div>
            <div class="stat-card"><div class="stat-label">${t('stats.wins')}</div><div class="stat-value">${totalWins}</div></div>
            <div class="stat-card"><div class="stat-label">${t('profile.winRate')}</div><div class="stat-value">${winRate}%</div></div>
            <div class="stat-card" title="${t('stats.totalScoresTip')}"><div class="stat-label">${t('stats.totalScores')}</div><div class="stat-value">${Math.round(totalPoints)}</div></div>
            <div class="stat-card"><div class="stat-label">${t('stats.distinctGames')}</div><div class="stat-value">${distinctGames}</div></div>
        </div>
        <h3 style="margin-top:16px;">${t('cross.perClub')}</h3>
        <div class="table-responsive"><table>
            <thead><tr><th style="text-align:left;">${t('stats.club')}</th><th>${t('stats.sessions')}</th><th>${t('stats.wins')}</th><th>${t('stats.winRateH')}</th><th>${t('stats.scoresH')}</th></tr></thead>
            <tbody>${clubRows.map(r => `<tr>
                <td style="text-align:left;">${clubEsc(r.name)}</td><td>${r.sessions}</td><td>${r.wins}</td>
                <td><strong>${r.rate}%</strong></td><td>${Math.round(r.points)}</td>
            </tr>`).join('')}</tbody>
        </table></div>
        ${topGames.length ? `<h3 style="margin-top:16px;">${t('stats.topGamesAll')}</h3>
            <div class="table-responsive"><table><thead><tr><th style="text-align:left;">${t('stats.game')}</th><th>${t('stats.plays')}</th></tr></thead>
            <tbody>${topGames.map(g => `<tr><td style="text-align:left;">${clubEsc(g[0])}</td><td>${g[1]}</td></tr>`).join('')}</tbody></table></div>` : ''}
    `;
}

/* ---------- Win rate per rol/facțiune (plan Pro+) ---------- */
function renderRoleWinRateStats(container, period) {
    if (!planAllows('advancedStats')) { container.innerHTML = featureLockNote('advancedStats'); return; }
    const games = (typeof getGamesByPeriod === 'function') ? getGamesByPeriod(period) : (state.games || []);
    /* perGame[gameName][role] = { plays, wins } */
    const perGame = {};
    games.forEach(g => {
        if (g.friendly || (g.meta && g.meta.friendly)) return; /* amicalele nu contează la stats de performanță (§12.d) */
        if (!g.roles || typeof g.roles !== 'object') return;
        const gname = g.gameName || g.game_title || 'Joc';
        const winners = new Set((g.winners || []));
        Object.keys(g.roles).forEach(pl => {
            const role = g.roles[pl];
            if (!role) return;
            perGame[gname] = perGame[gname] || {};
            const r = perGame[gname][role] || (perGame[gname][role] = { plays: 0, wins: 0 });
            r.plays += 1;
            if (winners.has(pl)) r.wins += 1;
        });
    });

    const gnames = Object.keys(perGame).sort();
    if (!gnames.length) {
        container.innerHTML = `<p style="opacity:0.7;">${t('roleStats.empty')}</p>`;
        return;
    }
    container.innerHTML = gnames.map(gn => {
        const roles = Object.keys(perGame[gn])
            .map(role => { const x = perGame[gn][role]; return { role, plays: x.plays, wins: x.wins, rate: x.plays ? Math.round((x.wins / x.plays) * 100) : 0 }; })
            .sort((a, b) => b.rate - a.rate || b.plays - a.plays);
        return `<div class="card" style="margin-bottom:14px;">
            <h3 style="margin-bottom:8px;">${clubEsc(gn)}</h3>
            <div class="table-responsive"><table>
                <thead><tr><th style="text-align:left;">${t('stats.roleFaction')}</th><th>${t('stats.plays')}</th><th>${t('stats.wins')}</th><th>${t('stats.winRateH')}</th></tr></thead>
                <tbody>${roles.map(r => `<tr>
                    <td style="text-align:left;">${clubEsc(r.role)}</td>
                    <td>${r.plays}</td><td>${r.wins}</td>
                    <td><strong>${r.rate}%</strong></td>
                </tr>`).join('')}</tbody>
            </table></div>
        </div>`;
    }).join('');
}

/* ---------- H-Index (metrică BGG): cel mai mare N pentru care există
   cel puțin N jocuri diferite, jucate fiecare de cel puțin N ori. ---------- */
function computeHIndex(countsArr) {
    const arr = countsArr.slice().sort((a, b) => b - a);
    let h = 0;
    for (let i = 0; i < arr.length; i++) { if (arr[i] >= i + 1) h = i + 1; else break; }
    return h;
}

function renderHIndexStats(container, period) {
    if (!planAllows('advancedStats')) { container.innerHTML = featureLockNote('advancedStats'); return; }
    const games = (typeof getGamesByPeriod === 'function') ? getGamesByPeriod(period) : (state.games || []);
    const clubCounts = {};
    const perPlayer = {};
    games.forEach(g => {
        const name = g.gameName || g.game_title || 'Joc';
        clubCounts[name] = (clubCounts[name] || 0) + 1;
        (g.participants || []).forEach(p => {
            perPlayer[p] = perPlayer[p] || {};
            perPlayer[p][name] = (perPlayer[p][name] || 0) + 1;
        });
    });
    const clubH = computeHIndex(Object.values(clubCounts));
    const distinctGames = Object.keys(clubCounts).length;
    const totalPlays = Object.values(clubCounts).reduce((a, b) => a + b, 0);

    const rows = Object.keys(perPlayer).map(p => {
        const counts = Object.values(perPlayer[p]);
        const top = Object.keys(perPlayer[p])
            .map(g => [g, perPlayer[p][g]])
            .sort((a, b) => b[1] - a[1]).slice(0, 3)
            .map(x => `${clubEsc(x[0])} (${x[1]})`).join(', ');
        const nm = (typeof displayNameById === 'function' && displayNameById(p)) || p;
        return { name: nm, h: computeHIndex(counts), distinct: counts.length, top };
    }).sort((a, b) => b.h - a.h || b.distinct - a.distinct);

    container.innerHTML = `
        <div class="stats-grid">
            <div class="stat-card"><div class="stat-label">${t('stats.hIndexClub')}</div><div class="stat-value">${clubH}</div></div>
            <div class="stat-card"><div class="stat-label">${t('stats.distinctGames')}</div><div class="stat-value">${distinctGames}</div></div>
            <div class="stat-card"><div class="stat-label">${t('stats.totalPlays')}</div><div class="stat-value">${totalPlays}</div></div>
        </div>
        <p style="color:var(--text-secondary); font-size:0.85em; margin:12px 0;">
            ${t('stats.hIndexNote')}
        </p>
        ${rows.length ? `<div class="table-responsive"><table>
            <thead><tr><th>#</th><th>${t('stats.player')}</th><th>H-Index</th><th>${t('stats.distinctGames')}</th><th>${t('stats.topGames')}</th></tr></thead>
            <tbody>${rows.map((r, i) => `<tr class="${i < 3 ? 'rank-' + (i + 1) : ''}${i >= 5 ? ' stats-hidden' : ''}"${i >= 5 ? ' data-more="hindex"' : ''}>
                <td>${i + 1}</td>
                <td style="text-align:left;">${clubEsc(r.name)}</td>
                <td><strong>${r.h}</strong></td>
                <td>${r.distinct}</td>
                <td style="text-align:left;">${r.top || '-'}</td>
            </tr>`).join('')}</tbody></table></div>
            ${statsMoreBtn('hindex', rows.length, 5)}`
        : '<p style="opacity:0.7;">' + t('stats.noMatchesPeriod') + '</p>'}
    `;
}

/* Mod de VIZUALIZARE pentru tabelul de jucători din Statistici (doar afișare):
   'raw' = suma scorurilor brute (implicit), 'club' = puncte de club din perioadă,
   calculate cu contribuția canonică per sesiune (_sessionContribution, §18). */
/* Implicit „Puncte", identic cu clasamentul (`_lbPtsView`): același comutator în
   două ecrane trebuie să pornească din aceeași stare, altfel utilizatorul crede că
   privește lucruri diferite. În cluburile fără uniformizare, `_uniOn` forțează
   oricum vederea pe „Scoruri" — vezi renderPlayerStats. */
window._plStatsPtsView = window._plStatsPtsView || 'club';
function setPlStatsPtsView(mode) {
    window._plStatsPtsView = (mode === 'club') ? 'club' : 'raw';
    updateStats();
}
window.setPlStatsPtsView = setPlStatsPtsView;

function renderPlayerStats(container, period) {
    const players = getSortedPlayers();
    /* Amicalele NU contează la statisticile jucătorilor (§12.d) — aliniat cu
       gamesPlayedById/countWins. Un singur set filtrat pentru TOT tabelul
       (inclusiv numitorul prezenței), ca să nu amestecăm definiții. */
    const periodGames = getGamesByPeriod(period)
        .filter(g => !(g.friendly || (g.meta && g.meta.friendly)));

    /* Fără uniformizare activă în club, comutatorul Puncte/Scoruri nu oferă o alegere
       reală — rămâne doar „Scoruri". Preferința globală nu se rescrie (vezi nota din
       renderLeaderboard). */
    const _uniOn = (typeof clubUniformScoringOn === 'function') ? clubUniformScoringOn() : true;
    const ptsMode = (_uniOn && window._plStatsPtsView !== 'raw') ? 'club' : 'raw';
    /* Contribuția de puncte de club per sesiune, precomputată o dată per joc
       (friendly=false — setul e deja filtrat). Oglinda regulii din DB (§18):
       uniform => clubPoints[pid]; raw => scores[pid] dacă > 0. */
    const contribByGame = new Map();
    if (ptsMode === 'club') {
        periodGames.forEach(g => {
            const c = (typeof _sessionContribution === 'function')
                ? _sessionContribution(g.scores, g.clubPoints, g.scoreMode === 'uniform', false)
                : {};
            contribByGame.set(g, c);
        });
    }
    
    // Calculate player statistics for the period
    const playerStats = players.map(player => {
        const pid = player.dbId || player.name;
        const playerGames = periodGames.filter(game => 
            game.participants?.includes(pid)
        );
        const gamesPlayed = playerGames.length;
        
        const totalPoints = playerGames.reduce((sum, game) => 
            sum + (ptsMode === 'club'
                ? (Number((contribByGame.get(game) || {})[pid]) || 0)
                : (Number(game.scores?.[pid]) || 0)), 0);
        
        /* Câștigătorul = STRICT din game.winners (§18.f) — respectă tie-break-ul
           uniformizat, coop-loss și campaniile. FĂRĂ fallback pe scorul maxim
           (ar „inventa" victorii la coop/campanii și ar diverge de countWins). */
        const wins = playerGames.filter(game =>
            Array.isArray(game.winners) && game.winners.includes(pid)
        ).length;
        
        const winRate = gamesPlayed > 0 ? (wins / gamesPlayed * 100).toFixed(1) : 0;
        const avgScore = gamesPlayed > 0 ? (totalPoints / gamesPlayed).toFixed(2) : 0;
        const attendanceRate = periodGames.length > 0 ? 
            (gamesPlayed / periodGames.length * 100).toFixed(1) : 0;
        
        return {
            name: player.name,
            gamesPlayed,
            totalPoints,
            avgScore,
            wins,
            winRate,
            attendanceRate
        };
    });
    
    // Sort by total points (ordinea tabelului + a graficului de distribuție)
    playerStats.sort((a, b) => b.totalPoints - a.totalPoints);
    /* Cardurile „best of" se calculează pe COPII (slice) — .sort() mută array-ul
       în loc; înainte, ultima sortare (prezență) strica top-8-ul graficului. */
    const bestAvg = playerStats.length ? playerStats.slice().sort((a, b) => b.avgScore - a.avgScore)[0] : null;
    const mostActive = playerStats.length ? playerStats.slice().sort((a, b) => b.gamesPlayed - a.gamesPlayed)[0] : null;
    const bestAttend = playerStats.length ? playerStats.slice().sort((a, b) => b.attendanceRate - a.attendanceRate)[0] : null;
    
    container.innerHTML = `
        ${_uniOn ? `<div class="pf-scope-toggle" role="group" style="margin-bottom:12px;">
            <button type="button" class="pf-scope-btn${ptsMode === 'club' ? ' active' : ''}" aria-pressed="${ptsMode === 'club'}" onclick="setPlStatsPtsView('club')"><i class="fas fa-coins"></i> ${t('stats.points')}</button>
            <button type="button" class="pf-scope-btn${ptsMode === 'raw' ? ' active' : ''}" aria-pressed="${ptsMode === 'raw'}" onclick="setPlStatsPtsView('raw')"><i class="fas fa-list-ol"></i> ${t('stats.scoresH')}</button>
        </div>` : ''}
        <div class="table-responsive">
            <table>
                <thead>
                    <tr>
                        <th>#</th>
                        <th>${t('stats.player')}</th>
                        <th>${t('stats.games')}</th>
                        <th>${t(ptsMode === 'club' ? 'stats.points' : 'stats.scoresH')}</th>
                        <th>${t('stats.average')}</th>
                        <th>${t('stats.wins')}</th>
                        <th>${t('stats.winRateH')}</th>
                        <th>${t('stats.attendance')}</th>
                    </tr>
                </thead>
                <tbody>
                    ${playerStats.map((stat, index) => `
                        <tr class="${index < 3 ? `rank-${index + 1}` : ''}${index >= 5 ? ' stats-hidden' : ''}"${index >= 5 ? ' data-more="plStats"' : ''}>
                            <td>${index + 1}</td>
                            <td style="text-align: left;">${window.escHtml(stat.name)}</td>
                            <td>${stat.gamesPlayed}</td>
                            <td><strong>${stat.totalPoints.toFixed(1)}</strong></td>
                            <td>${stat.avgScore}</td>
                            <td>${stat.wins}</td>
                            <td>${stat.winRate}%</td>
                            <td>${stat.attendanceRate}%</td>
                        </tr>
                    `).join('')}
                </tbody>
            </table>
        </div>
        ${statsMoreBtn('plStats', playerStats.length, 5)}
        
        <div class="stats-grid mt-20">
            <div class="stat-card">
                <div class="stat-label">${t('stats.playerOfMonth')}</div>
                <div class="stat-value" style="font-size: 1.4em;">
                    ${playerStats.length > 0 ? window.escHtml(playerStats[0].name) : '-'}
                </div>
                <div class="stat-change positive">
                    ${playerStats.length > 0 ? `${playerStats[0].totalPoints.toFixed(1)} ${t('stats.ptsWord')}` : '-'}
                </div>
            </div>
            <div class="stat-card">
                <div class="stat-label">${t('stats.bestAverage')}</div>
                <div class="stat-value" style="font-size: 1.4em;">
                    ${bestAvg ? window.escHtml(bestAvg.name) : '-'}
                </div>
                <div class="stat-change positive">
                    ${bestAvg ? parseFloat(bestAvg.avgScore).toFixed(2) : '-'}
                </div>
            </div>
            <div class="stat-card">
                <div class="stat-label">${t('stats.mostActive')}</div>
                <div class="stat-value" style="font-size: 1.4em;">
                    ${mostActive ? window.escHtml(mostActive.name) : '-'}
                </div>
                <div class="stat-change positive">
                    ${mostActive ? `${mostActive.gamesPlayed} ${t('elo.gamesWord')}` : '-'}
                </div>
            </div>
            <div class="stat-card">
                <div class="stat-label">${t('stats.bestAttendance')}</div>
                <div class="stat-value" style="font-size: 1.4em;">
                    ${bestAttend ? window.escHtml(bestAttend.name) : '-'}
                </div>
                <div class="stat-change positive">
                    ${bestAttend ? `${parseFloat(bestAttend.attendanceRate).toFixed(1)}%` : '-'}
                </div>
            </div>
        </div>
        
        <div class="card mt-20">
            <h3><i class="fas fa-chart-pie"></i> ${t('stats.pointsDistribution')}</h3>
            <div id="playerPointsChart" style="margin-top: 20px;"></div>
        </div>
    `;
    
    // Create pie chart for points distribution
    createPlayerPointsChart(playerStats.slice(0, 8)); // Top 8 players
}

function getGamesByPeriod(period) {
    const now = new Date();
    let startDate;
    
    switch(period) {
        /* RO: `now.setX(...)` MUTA obiectul `now`, apoi îl împachetează într-un
               Date nou — deci după `switch` variabila nu mai înseamnă „acum".
               În plus, `setMonth` fără limitare aluneca cu 1–3 zile în zilele de
               29–31, iar `setFullYear` pe 29 februarie sărea în 1 martie.
               `addMonths`/`addDays` nu ating originalul și limitează ziua.
           EN: the old code mutated `now` and overflowed on month ends. */
        case 'week':
            startDate = addDays(now, -7);
            break;
        case 'month':
            startDate = addMonths(now, -1);
            break;
        case 'quarter':
            startDate = addMonths(now, -3);
            break;
        case 'year':
            startDate = addYears(now, -1);
            break;
        default: // 'all'
            startDate = new Date(0);
    }
    
    return state.games.filter(game => 
        new Date(game.timestamp) >= startDate
    );
}

function createPlayerPointsChart(playerStats) {
    const container = document.getElementById('playerPointsChart');
    if (!container) return;
    
    if (playerStats.length === 0) {
        container.innerHTML = `
            <div style="text-align: center; padding: 50px; color: var(--text-secondary);">
                <i class="fas fa-chart-pie" style="font-size: 3em;"></i>
                <p>${t('stats.noChartData')}</p>
            </div>
        `;
        return;
    }
    
    // Create simple chart with divs
    const maxPoints = Math.max(...playerStats.map(p => p.totalPoints));
    const totalPoints = playerStats.reduce((sum, p) => sum + p.totalPoints, 0);
    
    container.innerHTML = `
        <div style="display: flex; flex-wrap: wrap; gap: 20px; justify-content: center;">
            <div style="flex: 1; min-width: 300px;">
                <div style="display: flex; flex-direction: column; gap: 15px;">
                    ${playerStats.map(stat => {
                        const percentage = totalPoints > 0 ? (stat.totalPoints / totalPoints * 100).toFixed(1) : 0;
                        const width = totalPoints > 0 ? (stat.totalPoints / maxPoints * 100) : 0;
                        
                        return `
                            <div>
                                <div style="display: flex; justify-content: space-between; margin-bottom: 5px;">
                                    <span style="font-weight: bold;">${window.escHtml(stat.name)}</span>
                                    <span>${stat.totalPoints.toFixed(1)} ${t('stats.ptsWord')} (${percentage}%)</span>
                                </div>
                                <div style="
                                    height: 20px;
                                    background: var(--gradient-primary, linear-gradient(90deg, #ff6b35, #f9a826));
                                    border-radius: 10px;
                                    width: ${width}%;
                                    transition: width 1s ease;
                                "></div>
                            </div>
                        `;
                    }).join('')}
                </div>
            </div>
            <div style="flex: 0 0 200px;">
                <div style="display: flex; flex-direction: column; gap: 10px;">
                    <div style="text-align: center; padding: 20px; background: var(--bg-secondary); border-radius: 10px;">
                        <div style="font-size: 2em; color: var(--accent-primary); font-weight: bold;">
                            ${totalPoints.toFixed(1)}
                        </div>
                        <div style="color: var(--text-secondary);">${t('stats.totalPoints')}</div>
                    </div>
                    <div style="text-align: center; padding: 20px; background: var(--bg-secondary); border-radius: 10px;">
                        <div style="font-size: 2em; color: var(--success); font-weight: bold;">
                            ${playerStats.length}
                        </div>
                        <div style="color: var(--text-secondary);">${t('stats.players')}</div>
                    </div>
                    <div style="text-align: center; padding: 20px; background: var(--bg-secondary); border-radius: 10px;">
                        <div style="font-size: 2em; color: var(--accent-gold); font-weight: bold;">
                            ${(totalPoints / playerStats.length).toFixed(1)}
                        </div>
                        <div style="color: var(--text-secondary);">${t('stats.avgPerPlayer')}</div>
                    </div>
                </div>
            </div>
        </div>
    `;
}

function renderGameStats(container, period) {
    const periodGames = getGamesByPeriod(period);
    
    // Calculate game statistics
    const gameStats = {};
    
    periodGames.forEach(game => {
        if (!game.gameName) return;
        
        if (!gameStats[game.gameName]) {
            gameStats[game.gameName] = {
                name: game.gameName,
                plays: 0,
                totalPlayers: 0,
                totalDuration: 0,
                totalPoints: 0,
                lastPlayed: null,
                gameInfo: state.catalog[game.gameName] || {}
            };
        }
        
        const stats = gameStats[game.gameName];
        stats.plays++;
        stats.totalPlayers += game.participants?.length || 0;
        stats.totalDuration += game.duration || 0;
        
        // Calculate total points from this game session
        if (game.scores) {
            const gamePoints = Object.values(game.scores).reduce((sum, score) => sum + (Number(score) || 0), 0);
            stats.totalPoints += gamePoints;
        }
        
        // Update last played date
        const gameDate = new Date(game.timestamp);
        if (!stats.lastPlayed || gameDate > new Date(stats.lastPlayed)) {
            stats.lastPlayed = game.timestamp;
        }
    });
    
    // Convert to array and sort by number of plays
    const gameStatsArray = Object.values(gameStats).sort((a, b) => b.plays - a.plays);
    
    container.innerHTML = `
        <div class="table-responsive">
            <table>
                <thead>
                    <tr>
                        <th>#</th>
                        <th>${t('stats.game')}</th>
                        <th>${t('stats.games')}</th>
                        <th>${t('stats.players')}</th>
                        <th>${t('stats.duration')}</th>
                        <th>${t('stats.scoresH')}</th>
                        <th>${t('stats.lastPlayed')}</th>
                        <th>${t('stats.rating')}</th>
                    </tr>
                </thead>
                <tbody>
                    ${gameStatsArray.map((game, index) => {
                        const avgPlayers = game.plays > 0 ? (game.totalPlayers / game.plays).toFixed(1) : 0;
                        const avgDuration = game.plays > 0 ? Math.round(game.totalDuration / game.plays) : 0;
                        const avgPoints = game.plays > 0 ? (game.totalPoints / game.plays).toFixed(1) : 0;
                        const lastPlayed = game.lastPlayed ? 
                            new Date(game.lastPlayed).toLocaleDateString('en-GB') : t('common.never');
                        const rating = game.gameInfo.rating || 'N/A';
                        
                        return `
                            <tr class="${index < 3 ? `rank-${index + 1}` : ''}${index >= 5 ? ' stats-hidden' : ''}"${index >= 5 ? ' data-more="gameStats"' : ''}>
                                <td>${index + 1}</td>
                                <td style="text-align: left;">
                                    <strong>${window.escHtml(game.name)}</strong>
                                    ${game.gameInfo.categories ? `
                                        <div style="font-size: 0.8em; color: var(--text-secondary);">
                                            ${game.gameInfo.categories.slice(0, 2).join(', ')}
                                        </div>
                                    ` : ''}
                                </td>
                                <td>${game.plays}</td>
                                <td>${avgPlayers}</td>
                                <td>${avgDuration} min</td>
                                <td>${avgPoints}</td>
                                <td>${lastPlayed}</td>
                                <td>${rating}/10</td>
                            </tr>
                        `;
                    }).join('')}
                </tbody>
            </table>
        </div>
        ${statsMoreBtn('gameStats', gameStatsArray.length, 5)}
        
        <div class="stats-grid mt-20">
            <div class="stat-card">
                <div class="stat-label">${t('stats.mostPlayedStat')}</div>
                <div class="stat-value" style="font-size: 1.4em;">
                    ${gameStatsArray.length > 0 ? window.escHtml(gameStatsArray[0].name) : '-'}
                </div>
                <div class="stat-change positive">
                    ${gameStatsArray.length > 0 ? `${gameStatsArray[0].plays} jocuri` : '-'}
                </div>
            </div>
            <div class="stat-card">
                <div class="stat-label">${t('stats.longestAverage')}</div>
                <div class="stat-value" style="font-size: 1.4em;">
                    ${gameStatsArray.length > 0 ? 
                        gameStatsArray.sort((a, b) => (b.totalDuration/b.plays) - (a.totalDuration/a.plays))[0].name : '-'}
                </div>
                <div class="stat-change positive">
                    ${gameStatsArray.length > 0 ? 
                        `${Math.round(gameStatsArray.sort((a, b) => (b.totalDuration/b.plays) - (a.totalDuration/a.plays))[0].totalDuration/gameStatsArray[0].plays)} min` : '-'}
                </div>
            </div>
            <div class="stat-card">
                <div class="stat-label">${t('plans.mostPopular')}</div>
                <div class="stat-value" style="font-size: 1.4em;">
                    ${gameStatsArray.length > 0 ? 
                        gameStatsArray.sort((a, b) => (b.totalPlayers/b.plays) - (a.totalPlayers/a.plays))[0].name : '-'}
                </div>
                <div class="stat-change positive">
                    ${gameStatsArray.length > 0 ? 
                        `${(gameStatsArray.sort((a, b) => (b.totalPlayers/b.plays) - (a.totalPlayers/a.plays))[0].totalPlayers/gameStatsArray[0].plays).toFixed(1)} ${t('common.players')}` : '-'}
                </div>
            </div>
            <div class="stat-card">
                <div class="stat-label">${t('stats.totalGames')}</div>
                <div class="stat-value">${gameStatsArray.reduce((sum, g) => sum + g.plays, 0)}</div>
                <div class="stat-change positive">
                    ${periodGames.length} sesiuni
                </div>
            </div>
        </div>
        
        <div class="card mt-20">
            <h3><i class="fas fa-chart-bar"></i> ${t('stats.gameDistribution')}</h3>
            <div id="gamesChart" style="height: 300px; margin-top: 20px;"></div>
        </div>
    `;
    
    // Create bar chart for game distribution
    createGamesChart(gameStatsArray.slice(0, 10)); // Top 10 games
}

function createGamesChart(games) {
    const container = document.getElementById('gamesChart');
    if (!container) return;
    
    if (games.length === 0) {
        container.innerHTML = `
            <div style="text-align: center; padding: 50px; color: var(--text-secondary);">
                <i class="fas fa-chart-bar" style="font-size: 3em;"></i>
                <p>${t('stats.noChartData')}</p>
            </div>
        `;
        return;
    }
    
    const maxPlays = Math.max(...games.map(g => g.plays));
    
    container.innerHTML = `
        <div style="display: flex; align-items: flex-end; height: 250px; gap: 10px; padding: 20px;">
            ${games.map(game => {
                const height = maxPlays > 0 ? (game.plays / maxPlays * 100) : 5;
                return `
                    <div style="flex: 1; display: flex; flex-direction: column; align-items: center;">
                        <div style="
                            width: 30px;
                            height: ${height}%;
                            background: var(--gradient-primary);
                            border-radius: 8px 8px 0 0;
                            position: relative;
                            transition: height 0.5s ease;
                        ">
                            <div style="
                                position: absolute;
                                top: -25px;
                                left: 50%;
                                transform: translateX(-50%);
                                color: var(--accent-primary);
                                font-weight: bold;
                                font-size: 12px;
                            ">${game.plays}</div>
                        </div>
                        <div style="margin-top: 10px; color: var(--text-secondary); font-size: 11px; text-align: center; height: 40px; overflow: hidden;">
                            ${window.escHtml(game.name)}
                        </div>
                    </div>
                `;
            }).join('')}
        </div>
    `;
}

/* RO: Variația față de subunitatea anterioară. Fără bază de comparație (zero sau
       o singură subunitate) NU inventăm „+0%": afișam verde „fără schimbare" acolo
       unde adevărul era „de la nimic la 50". Aceeași gardă ca la observații.
   EN: no baseline -> show a dash, not a misleading +0%. */
function _trendChangeTxt(trendData, camp) {
    if (!trendData || trendData.length < 2) return '—';
    const acum = Number(trendData[trendData.length - 1][camp]) || 0;
    const inainte = Number(trendData[trendData.length - 2][camp]) || 0;
    if (inainte === 0) return acum > 0 ? t('stats.changeNew') : '—';
    const p = (acum - inainte) / inainte * 100;
    return (p > 0 ? '+' : '') + p.toFixed(0) + '%';
}

function renderTrendStats(container, period) {
    // Get data for last 6 periods
    const periods = getHistoricalPeriods(period);
    
    const trendData = periods.map((periodData, index) => {
        const stats = calculatePeriodStatsForTrend(periodData.start, periodData.end);
        return {
            period: periodData.label,
            ...stats
        };
    });
    
    container.innerHTML = `
        <div class="card">
            <h3><i class="fas fa-chart-line"></i> ${t('stats.trendsTitle')} · ${getPeriodLabel(period)}</h3>
            
            <div class="stats-grid mt-20">
                <div class="stat-card ${trendData.length < 2 ? '' : (trendData[trendData.length-1].totalSessions > trendData[trendData.length-2].totalSessions ? 'trend-up' : 'trend-down')}">
                    <div class="stat-label">${t('stats.sessions')}</div>
                    <div class="stat-value">${trendData.length > 0 ? trendData[trendData.length-1].totalSessions : 0}</div>
                    ${trendData.length > 1 ? `
                        <div class="stat-change ${trendData[trendData.length-1].totalSessions > trendData[trendData.length-2].totalSessions ? 'positive' : 'negative'}">
                            ${trendData[trendData.length-1].totalSessions > trendData[trendData.length-2].totalSessions ? '+' : ''}
                            ${_trendChangeTxt(trendData, 'totalSessions')}
                        </div>
                    ` : ''}
                </div>
                
                <div class="stat-card ${trendData.length < 2 ? '' : (trendData[trendData.length-1].uniquePlayers > trendData[trendData.length-2].uniquePlayers ? 'trend-up' : 'trend-down')}">
                    <div class="stat-label">${t('stats.players')}</div>
                    <div class="stat-value">${trendData.length > 0 ? trendData[trendData.length-1].uniquePlayers : 0}</div>
                    ${trendData.length > 1 ? `
                        <div class="stat-change ${trendData[trendData.length-1].uniquePlayers > trendData[trendData.length-2].uniquePlayers ? 'positive' : 'negative'}">
                            ${trendData[trendData.length-1].uniquePlayers > trendData[trendData.length-2].uniquePlayers ? '+' : ''}
                            ${_trendChangeTxt(trendData, 'uniquePlayers')}
                        </div>
                    ` : ''}
                </div>
                
                <div class="stat-card ${trendData.length < 2 ? '' : (trendData[trendData.length-1].avgScore > trendData[trendData.length-2].avgScore ? 'trend-up' : 'trend-down')}">
                    <div class="stat-label">${t('stats.avgScore')}</div>
                    <div class="stat-value">${trendData.length > 0 ? trendData[trendData.length-1].avgScore.toFixed(1) : 0}</div>
                    ${trendData.length > 1 ? `
                        <div class="stat-change ${trendData[trendData.length-1].avgScore > trendData[trendData.length-2].avgScore ? 'positive' : 'negative'}">
                            ${trendData[trendData.length-1].avgScore > trendData[trendData.length-2].avgScore ? '+' : ''}
                            ${_trendChangeTxt(trendData, 'avgScore')}
                        </div>
                    ` : ''}
                </div>
                
                <div class="stat-card ${trendData.length < 2 ? '' : (trendData[trendData.length-1].totalHours > trendData[trendData.length-2].totalHours ? 'trend-up' : 'trend-down')}">
                    <div class="stat-label">${t('stats.playHours')}</div>
                    <div class="stat-value">${trendData.length > 0 ? trendData[trendData.length-1].totalHours : 0}</div>
                    ${trendData.length > 1 ? `
                        <div class="stat-change ${trendData[trendData.length-1].totalHours > trendData[trendData.length-2].totalHours ? 'positive' : 'negative'}">
                            ${trendData[trendData.length-1].totalHours > trendData[trendData.length-2].totalHours ? '+' : ''}
                            ${_trendChangeTxt(trendData, 'totalHours')}
                        </div>
                    ` : ''}
                </div>
            </div>
            
            <div id="trendChart" style="height: 300px; margin-top: 30px;"></div>
            
            <!-- RO: Erau PATRU chenare concentrice pentru un rand de text: cardul
                 exterior (Tendinte), cardul Insights, containerul cu fundal propriu
                 si cutia fiecarei observatii. Acum ramane UNUL singur, cel exterior:
                 sectiunea e delimitata doar printr-o linie de sus, iar observatiile
                 prin bara colorata din stanga.
                 (comentariu fara accente si fara ghilimele inverse: e INTR-UN
                 template literal, unde un backtick ar inchide sirul) -->
            <div class="mt-20" style="border-top:1px solid var(--border); padding-top:18px;">
                <h4 style="margin:0 0 12px;"><i class="fas fa-lightbulb"></i> ${t('insights.title')}</h4>
                <div id="trendInsights" style="display:flex; flex-direction:column; gap:8px;"></div>
            </div>
        </div>
    `;
    
    // Create trend chart
    createTrendChart(trendData);
    
    // Generate insights
    generateTrendInsights(trendData, periods);
}

/* Aritmetică de luni FĂRĂ derapaj: `setMonth` pe 29–31 ale lunii poate „sări"
   în luna următoare (31 mar - 1 lună => 3 mar? nu: 31 feb => 3 mar). Clamp-uim
   ziua la ultima zi a lunii țintă, ca granițele perioadelor să rămână stabile. */
/* Păstrat ca alias: logica s-a mutat în `addMonths` (app-core.js), folosită acum
   de tot proiectul. Două implementări ale aceleiași reguli ar fi divergent la
   prima modificare — exact tiparul care a produs bug-ul din dashboard. */
function _addMonthsClamped(base, delta) { return addMonths(base, delta); }

/* ===== SUBUNITĂȚILE INTERVALULUI ALES =======================================
   RO: Selectorul „Perioadă" e un FILTRU DE INTERVAL — „Tot timpul", „Luna
       aceasta", „Anul acesta" — și așa îl folosesc toate celelalte tab-uri.
       Tab-ul Tendințe îl reinterpreta ca GRANULARITATE: alegeai „Anul acesta" și
       primeai ultimii ȘASE ANI, alegeai „Tot timpul" și primeai ultimele șase
       luni. Un control, două înțelesuri.

       Acum graficul arată EXACT intervalul ales, împărțit în subunități naturale:
         săptămâna  -> 7 zile
         luna       -> săptămânile lunii
         trimestrul -> cele 3 luni
         anul       -> cele 12 luni
         tot timpul -> câte un an, din primul an cu sesiuni până azi
   EN: the period selector is a RANGE filter everywhere else; Trends treated it as
       a bucket size. Now the chart shows the chosen range, split into sub-buckets.
   ============================================================================ */
function getHistoricalPeriods(periodType) {
    const locale = appDateLocale();
    const now = new Date();
    const periods = [];
    const push = (start, end, label) => periods.push({ label: label.charAt(0).toUpperCase() + label.slice(1), start, end });

    if (periodType === 'week') {
        /* Ultimele 7 zile, ziua curentă inclusă. */
        const azi = new Date(now); azi.setHours(0, 0, 0, 0);
        for (let i = 6; i >= 0; i--) {
            const s = addDays(azi, -i);
            push(s, addDays(s, 1), s.toLocaleDateString(locale, { weekday: 'short' }));
        }
        return periods;
    }

    if (periodType === 'month') {
        /* Săptămânile lunii curente, tăiate la începutul lunii și la ziua de azi:
           nu desenăm săptămâni care n-au venit încă. */
        const inceputLuna = startOfMonth(now);
        const maine = addDays(new Date(now.getFullYear(), now.getMonth(), now.getDate()), 1);
        let s = new Date(inceputLuna), idx = 1;
        while (s < maine) {
            const e = addDays(s, 7);
            push(new Date(s), e > maine ? new Date(maine) : e, t('stats.weekShort') + ' ' + idx);
            s = e; idx++;
        }
        return periods;
    }

    if (periodType === 'quarter') {
        /* Cele 3 luni ale trimestrului curent, fără lunile viitoare. */
        const q = Math.floor(now.getMonth() / 3);
        const inceputTrim = new Date(now.getFullYear(), q * 3, 1);
        for (let i = 0; i < 3; i++) {
            const s = addMonths(inceputTrim, i);
            if (s > now) break;
            push(s, addMonths(inceputTrim, i + 1), s.toLocaleDateString(locale, { month: 'short' }));
        }
        return periods;
    }

    if (periodType === 'year') {
        /* Lunile anului curent, până la luna în curs inclusiv. */
        const inceputAn = new Date(now.getFullYear(), 0, 1);
        for (let i = 0; i <= now.getMonth(); i++) {
            const s = addMonths(inceputAn, i);
            push(s, addMonths(inceputAn, i + 1), s.toLocaleDateString(locale, { month: 'short' }));
        }
        return periods;
    }

    /* 'all' — câte un an, din primul an cu sesiuni. Fără istoric, arătăm doar anul
       curent: șase ani goi nu spun nimic despre club. */
    let primulAn = now.getFullYear();
    (state.games || []).forEach(g => {
        const d = new Date(g.timestamp);
        if (isFinite(d.getTime()) && d.getFullYear() < primulAn) primulAn = d.getFullYear();
    });
    /* Plafon de siguranță: un club cu o dată greșită în trecut n-are voie să
       genereze sute de bare. */
    if (now.getFullYear() - primulAn > 14) primulAn = now.getFullYear() - 14;
    for (let an = primulAn; an <= now.getFullYear(); an++) {
        push(new Date(an, 0, 1), new Date(an + 1, 0, 1), String(an));
    }
    return periods;
}

/* Numărul săptămânii ISO — funcție de sine stătătoare (înainte era o extensie
   pe Date.prototype, anti-pattern care poluează prototipul global). */
function isoWeekNum(input) {
    const date = new Date(input.getTime());
    date.setHours(0, 0, 0, 0);
    date.setDate(date.getDate() + 3 - (date.getDay() + 6) % 7);
    const week1 = new Date(date.getFullYear(), 0, 4);
    return 1 + Math.round(((date.getTime() - week1.getTime()) / 86400000 - 3 + (week1.getDay() + 6) % 7) / 7);
}

function calculatePeriodStatsForTrend(startDate, endDate) {
    const periodGames = state.games.filter(game => {
        const gameDate = new Date(game.timestamp);
        return gameDate >= startDate && gameDate < endDate;
    });
    
    const totalSessions = periodGames.length;
    const uniquePlayers = new Set(
        periodGames.flatMap(game => game.participants || [])
    ).size;
    
    const totalPoints = periodGames.reduce((sum, game) => 
        sum + Object.values(game.scores || {}).reduce((s, v) => s + (Number(v) || 0), 0), 0
    );
    
    const totalDuration = periodGames.reduce((sum, game) => sum + (game.duration || 0), 0);
    const totalHours = Math.round(totalDuration / 60);
    
    const avgScore = totalSessions > 0 ? (totalPoints / totalSessions) : 0;
    
    return {
        totalSessions,
        uniquePlayers,
        totalPoints,
        totalHours,
        avgScore
    };
}

/* Eticheta descrie INTERVALUL ales, nu mărimea gălețile. Înainte întorcea
   „Lunar"/„Anual", ceea ce contrazicea filtrul: alegeai „Anul acesta" și scria
   „Anual" peste un grafic cu șase ani. */
function getPeriodLabel(period) {
    switch (period) {
        case 'week': return t('stats.periodWeek');
        case 'month': return t('stats.periodMonth');
        case 'quarter': return t('stats.periodQuarter');
        case 'year': return t('stats.periodYear');
        default: return t('stats.periodAll');
    }
}

function createTrendChart(trendData) {
    const container = document.getElementById('trendChart');
    if (!container || trendData.length === 0) return;
    
    // Prepare data for the chart
    const labels = trendData.map(d => d.period);
    const sessions = trendData.map(d => d.totalSessions);
    const players = trendData.map(d => d.uniquePlayers);
    const scores = trendData.map(d => d.avgScore);
    
    const maxSessions = Math.max(...sessions);
    const maxPlayers = Math.max(...players);
    const maxScores = Math.max(...scores);
    
    container.innerHTML = `
        <div style="height: 250px; display: flex; align-items: flex-end; gap: clamp(4px, ${Math.round(120 / Math.max(1, trendData.length))}px, 20px); padding: 20px; position: relative;">
            <!-- Grid lines -->
            <div style="position: absolute; top: 0; left: 0; right: 0; bottom: 0; display: flex; flex-direction: column; justify-content: space-between;">
                ${[0, 0.25, 0.5, 0.75, 1].map(pos => `
                    <div style="border-top: 1px solid var(--border); opacity: 0.3; position: relative;">
                        <span style="position: absolute; left: -40px; top: -10px; color: var(--text-secondary); font-size: 12px;">
                            ${Math.round(pos * maxSessions)}
                        </span>
                    </div>
                `).join('')}
            </div>
            
            <!-- Data points -->
            <div style="flex: 1; display: flex; justify-content: space-around; align-items: flex-end; height: 100%;">
                ${labels.map((label, index) => {
                    const sessionHeight = maxSessions > 0 ? (sessions[index] / maxSessions * 100) : 0;
                    const playerHeight = maxPlayers > 0 ? (players[index] / maxPlayers * 100) : 0;
                    
                    return `
                        <div style="display: flex; flex-direction: column; align-items: center; height: 100%; width: 40px;">
                            <div style="display: flex; align-items: flex-end; height: 100%; gap: 3px; width: 100%;">
                                <!-- Sessions bar -->
                                <div style="
                                    width: 15px;
                                    height: ${sessionHeight}%;
                                    background: var(--accent-primary);
                                    border-radius: 4px 4px 0 0;
                                    position: relative;
                                ">
                                    <div style="
                                        position: absolute;
                                        top: -20px;
                                        left: 50%;
                                        transform: translateX(-50%);
                                        color: var(--accent-primary);
                                        font-weight: bold;
                                        font-size: 11px;
                                    ">${sessions[index]}</div>
                                </div>
                                
                                <!-- Players bar -->
                                <div style="
                                    width: 15px;
                                    height: ${playerHeight}%;
                                    background: var(--success);
                                    border-radius: 4px 4px 0 0;
                                    position: relative;
                                ">
                                    <div style="
                                        position: absolute;
                                        top: -20px;
                                        left: 50%;
                                        transform: translateX(-50%);
                                        color: var(--success);
                                        font-weight: bold;
                                        font-size: 11px;
                                    ">${players[index]}</div>
                                </div>
                            </div>
                            
                            <!-- Period label -->
                            <div style="margin-top: 10px; color: var(--text-secondary); font-size: 12px; text-align: center;">
                                ${label}
                            </div>
                        </div>
                    `;
                }).join('')}
            </div>
        </div>
        
        <!-- Legend -->
        <div style="display: flex; justify-content: center; gap: 20px; margin-top: 20px;">
            <div style="display: flex; align-items: center; gap: 5px;">
                <div style="width: 15px; height: 15px; background: var(--accent-primary); border-radius: 3px;"></div>
                <span style="font-size: 12px; color: var(--text-secondary);">${t('stats.sessions')}</span>
            </div>
            <div style="display: flex; align-items: center; gap: 5px;">
                <div style="width: 15px; height: 15px; background: var(--success); border-radius: 3px;"></div>
                <span style="font-size: 12px; color: var(--text-secondary);">${t('stats.uniquePlayers')}</span>
            </div>
        </div>
    `;
}

/* ===== INSIGHTS DIN TENDINȚE ================================================
   RO: Rescris. Ce era înainte:
       · doar 5 tipuri, dintre care unul (vârful de activitate) NU se afișa
         niciodată: `trendData` are câmpul `period`, iar codul citea `.label`,
         deci comparația `undefined !== undefined` era mereu falsă;
       · împărțiri fără gardă la zero — o perioadă anterioară fără sesiuni
         producea „+Infinity%";
       · „jucători" apărea doar la creștere, niciodată la scădere;
       · `totalHours` se calcula și nu era folosit nicăieri.

       Acum: 14 tipuri, ordonate după cât de interesante sunt (recorduri și
       noutăți întâi, apoi variații, apoi stabilitate), din care se afișează
       maximum 4. Un perete de observații nu e „viu", e zgomot.
   EN: rewritten — the peak insight never fired (wrong field name), divisions
       were unguarded, and totalHours was computed but never used.
   ============================================================================ */

/* Variație procentuală cu gardă la zero. Întoarce null când nu există bază de
   comparație — atunci nu spunem nimic, în loc să spunem „+Infinity%". */
function _trendPct(now, before) {
    if (!isFinite(now) || !isFinite(before) || before === 0) return null;
    return Math.round((now - before) / before * 100);
}

/* Sesiunile dintr-un interval, din starea deja încărcată. */
function _sessionsBetween(start, end) {
    return (state.games || []).filter(g => {
        const d = new Date(g.timestamp);
        return d >= start && d < end;
    });
}

function generateTrendInsights(trendData, periods) {
    const container = document.getElementById('trendInsights');
    if (!container || !Array.isArray(trendData) || trendData.length < 2) return;

    const cur = trendData[trendData.length - 1];
    const prev = trendData[trendData.length - 2];
    /* `prio` mai mic = mai sus. Recordurile și noutățile bat variațiile de rutină. */
    const out = [];
    /* `fam` = familia observației. Selecția finală ia CEL MULT UNA din fiecare
       familie: fără asta, orice club cu câteva sesiuni umplea toate cele patru
       locuri cu observații despre jocuri și oameni, iar cele despre evoluție nu
       ajungeau niciodată să fie afișate. Rezultatul arăta identic de la un club
       la altul, chiar dacă datele erau complet diferite. */
    /* ⚠ Iconița stă DOAR aici, niciodată în textul din `i18n.js`. Cele opt chei
       vechi aveau emoji-ul lipit la începutul traducerii, iar codul nou îl mai
       adăuga o dată — două iconițe pe același rând. Un text tradus descrie ce se
       întâmplă; cum arată e treaba locului unde se randează. */
    const add = (prio, fam, icon, key, params) => {
        let txt = t(key);
        if (params) Object.keys(params).forEach(k => { txt = txt.split('{' + k + '}').join(String(params[k])); });
        out.push({ prio, fam, icon, txt });
    };

    /* ---- 1. Recorduri și noutăți ---------------------------------------- */
    const maxSess = Math.max(...trendData.map(d => d.totalSessions));
    if (cur.totalSessions > 0 && cur.totalSessions === maxSess && trendData.length >= 3
        && trendData.filter(d => d.totalSessions === maxSess).length === 1) {
        add(0, 'record', '🏆', 'insights.recordSessions', { n: cur.totalSessions });
    }
    if (prev.totalSessions === 0 && cur.totalSessions > 0) {
        add(0, 'record', '🌅', 'insights.comeback', { n: cur.totalSessions });
    }

    /* ---- 2. Ce se joacă (din sesiunile perioadei) ------------------------ */
    if (Array.isArray(periods) && periods.length) {
        const p = periods[periods.length - 1];
        const jocuri = _sessionsBetween(p.start, p.end);
        const conta = {};
        jocuri.forEach(g => { const n = g.gameName || ''; if (n) conta[n] = (conta[n] || 0) + 1; });
        const nume = Object.keys(conta);

        if (nume.length) {
            const top = nume.sort((a, b) => conta[b] - conta[a])[0];
            if (conta[top] >= 2) add(2, 'joc', '🎲', 'insights.topGame', { game: top, n: conta[top] });
        }

        /* Jocuri jucate pentru PRIMA dată vreodată în perioada curentă. */
        const inainte = new Set((state.games || [])
            .filter(g => new Date(g.timestamp) < p.start)
            .map(g => g.gameName));
        const noi = nume.filter(n => !inainte.has(n));
        if (noi.length === 1) add(0, 'joc', '✨', 'insights.newGame', { game: noi[0] });
        else if (noi.length > 1) add(0, 'joc', '✨', 'insights.newGames', { n: noi.length, game: noi[0] });

        /* Varietate: câte titluri distincte la câte sesiuni. */
        if (jocuri.length >= 4) {
            const raport = nume.length / jocuri.length;
            if (raport >= 0.8) add(1, 'joc', '🌈', 'insights.variety', { n: nume.length, s: jocuri.length });
            else if (raport <= 0.35) add(1, 'joc', '🔁', 'insights.focused', { game: nume.sort((a, b) => conta[b] - conta[a])[0] });
        }

        /* Mărimea medie a grupului. */
        const totalJuc = jocuri.reduce((s, g) => s + ((g.participants || []).length + ((g.guests || []).length || 0)), 0);
        if (jocuri.length >= 3 && totalJuc > 0) {
            const medie = (totalJuc / jocuri.length).toFixed(1);
            add(2, 'oameni', '🪑', 'insights.groupSize', { n: medie });
        }

        /* Cel mai prezent membru al perioadei. */
        const prez = {};
        jocuri.forEach(g => (g.participants || []).forEach(id => { prez[id] = (prez[id] || 0) + 1; }));
        const ids = Object.keys(prez);
        if (ids.length && jocuri.length >= 3) {
            const campion = ids.sort((a, b) => prez[b] - prez[a])[0];
            if (prez[campion] >= Math.ceil(jocuri.length * 0.6)) {
                const nm = (typeof displayNameById === 'function' && displayNameById(campion)) || campion;
                add(0, 'oameni', '🔥', 'insights.mostPresent', { name: nm, n: prez[campion], s: jocuri.length });
            }
        }
    }

    /* ---- 3. Variații față de perioada anterioară ------------------------- */
    const dSess = _trendPct(cur.totalSessions, prev.totalSessions);
    if (dSess !== null) {
        if (dSess > 10) add(0, 'evolutie', '📈', 'insights.sessUp', { n: dSess });
        else if (dSess < -10) add(0, 'evolutie', '📉', 'insights.sessDown', { n: dSess });
    }

    const dPl = _trendPct(cur.uniquePlayers, prev.uniquePlayers);
    if (dPl !== null) {
        if (dPl > 15) add(1, 'oameni', '👥', 'insights.players', { n: dPl });
        else if (dPl < -15) add(1, 'oameni', '🫥', 'insights.playersDown', { n: Math.abs(dPl) });
    }

    const dH = _trendPct(cur.totalHours, prev.totalHours);
    if (dH !== null && cur.totalHours > 0) {
        if (dH > 20) add(1, 'evolutie', '⏱️', 'insights.hoursUp', { n: cur.totalHours });
        else if (dH < -20) add(1, 'evolutie', '💤', 'insights.hoursDown', { n: cur.totalHours });
    }

    const dSc = _trendPct(cur.avgScore, prev.avgScore);
    if (dSc !== null) {
        if (dSc > 5) add(2, 'evolutie', '🎯', 'insights.scoreUp', { n: dSc });
        else if (dSc < -5) add(2, 'evolutie', '😊', 'insights.scoreDown', {});
    }

    /* ---- 4. Vârf de activitate ------------------------------------------ */
    /* ⚠ `trendData` are câmpul `period`, NU `label`. Codul vechi citea `.label`,
       deci condiția era `undefined !== undefined` = false, iar observația asta nu
       s-a afișat niciodată. */
    const varf = trendData.find(d => d.totalSessions === maxSess);
    if (varf && maxSess > 0 && varf.period !== cur.period) {
        add(1, 'record', '🏆', 'insights.peak', { label: varf.period, n: maxSess });
    }

    /* ---- 5. Rutină (ultimul, e cel mai puțin surprinzător) --------------- */
    const constante = trendData.filter((d, i, a) => i > 0 && Math.abs(d.totalSessions - a[i - 1].totalSessions) <= 2).length;
    if (constante >= 3) add(3, 'evolutie', '🔄', 'insights.routine', {});
    else if (dSess !== null && Math.abs(dSess) <= 10) add(3, 'evolutie', '⚖️', 'insights.sessStable', {});

    /* ---- Afișare: maximum 4, cele mai interesante întâi ------------------ */
    if (!out.length) {
        container.innerHTML = `<p style="color: var(--text-secondary); text-align: center;">${t('insights.none')}</p>`;
        return;
    }
    out.sort((a, b) => a.prio - b.prio);
    /* Un rând din fiecare familie (record / joc / oameni / evoluție), în ordinea
       interesului. Dacă rămân locuri libere — un club fără destule date pentru
       toate familiile — se completează cu următoarele ca prioritate. */
    const ales = [];
    const familiiLuate = new Set();
    out.forEach(o => { if (ales.length < 4 && !familiiLuate.has(o.fam)) { familiiLuate.add(o.fam); ales.push(o); } });
    out.forEach(o => { if (ales.length < 4 && ales.indexOf(o) === -1) ales.push(o); });
    /* Fără cutie proprie și fără fundal: rămâne UN singur chenar, cel al secțiunii
       de Tendințe. Observațiile se disting prin bara colorată din stânga, nu prin
       încă un dreptunghi. Trei chenare concentrice pentru un rând de text arătau
       ca o eroare de layout, nu ca o ierarhie. */
    container.innerHTML = ales.map(o => `
        <div style="display:flex; gap:10px; align-items:flex-start; padding:2px 0 2px 12px; border-left:3px solid var(--accent-primary);">
            <span aria-hidden="true" style="line-height:1.5;">${o.icon}</span>
            <span style="line-height:1.5;">${o.txt}</span>
        </div>
    `).join('');
}

